<template>
  <div>
    <switch
      v-model="updatesRunning"
      label="Updates uitzetten"
    ></switch>
    <v-alert
      v-if="!loading && conversionPackage.type == 'inactive'"
      type="info"
      prominent
      text
      class="py-0  mb-4"
      dense
      >
      <v-row align="center">
        <v-col class="grow">Het conversiepakket is nog niet actief voor {{ activeCompData.name }}. Hierdoor is het nog niet mogelijk om <strong>klantinformatie</strong> en <strong>conversie bronnen</strong> te bekijken.</v-col>
        <v-col class="shrink">
          <v-btn
            color="info"
            outlined
            href="https://pillarrr.io/demo/"
            target="_blank"
            >
            Vraag een gratis demo aan
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-alert
      v-if="!loading && conversionPackage.type == 'trial'"
      type="info"
      icon="timelapse"
      class="py-0 mb-4"
      mb-4
      prominent
      text
      dense
      >
      <v-row align="center">
        <v-col class="grow"><strong>Proefperiode</strong> van het conversiepakket is actief voor {{ activeCompData.name }}. Hierdoor is het nog  mogelijk om <strong>klantinformatie</strong>  en <strong>conversie bronnen</strong> te bekijken.</v-col>
        <v-col class="shrink">
          <v-btn
            color="info"
            outlined
            >
             Nog {{ conversionPackage.days }} <span style="color: #2196f3" v-if="conversionPackage.days == 1" >dag</span><span style="color: #2196f3" v-else>dagen</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
<!-- <div>
    <v-snackbar
        v-model="snackbar"
        centered
        :style="{top: 8 + 'px'}"
        top
        :min-width="500"
        color="rgba(0,0,0, 0.55)"
        :timeout="-1"
        class="update-snackbar"
        >
        <v-icon class="pr-2" color="#A5D6A7">sentiment_very_satisfied</v-icon>
        <span class="white--text"> Nieuwe conversie gestard voor Sven</span>
          <v-btn
            color="white"
            icon
            >
            <v-icon color="white">close</v-icon>
          </v-btn>
      </v-snackbar>
      </div> -->

    <div v-for="(update,index) in conversieUpdatesFiltered" :key="index + updateCounter">
      <v-snackbar
        centered
        :style="{top: index * 75 + 'px'}"
        v-model="update.show" 
        top
        :min-width="500"
        color="rgba(0,0,0, 0.55)"
        :timeout="-1"
        class="update-snackbar"
        >
        <v-icon class="pr-2" color="#A5D6A7">sentiment_very_satisfied</v-icon>
        <span class="white--text"> Nieuwe conversie gestard voor {{ updateCompany(update.company).name }}</span>
          <v-btn
            color="white"
            icon
 
            @click="update.show = false"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
      </v-snackbar>
    </div>

    <div v-if="!demoMode && !loading && companies.length > 1" class="content-header-minimum barometers clear">
      <div class="clear">
        <v-container grid-list-md class="pa-0" fluid>
          <v-layout row wrap>
            <v-flex md3 xs12>
              <v-select
                v-if="!loading && companies.length > 1"
                :items="filteredCompanies"
                :item-color="companyPrimaryColor"
                :background-color="$vuetify.theme.themes[theme].menu"
                item-text="name"
                item-value="id"
                v-on:input="loadActiveCompData()"
                v-model="activeComp"
                no-data-text="Geen bedrijven gevonden."
                label="Selecteer bedrijf"
                outlined
                hide-details
                dense>
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content  class="pt-0" >
                      <v-text-field
                        :color="companyPrimaryColor"
                        placeholder="Zoeken"
                        prepend-inner-icon="search"
                        clearable
                        v-model="searchCompanies"
                        hide-details
                        dense
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
                  <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
                </template>
              </v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </div>
  
  

    <v-card outlined v-if="!loading" class="mt-4">
      <v-container grid-list-md fluid class="ma-0 pa-1">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex md3 xs6>
            <v-btn :color="todaySelected.color" darken depressed :loading="todaySelected.loading" @click="filterConversionToday()" style="margin: 0; height: 48px;" block large><span :style="{color: todaySelected.textColor}">Vandaag</span></v-btn>
          </v-flex>
          <v-flex md3 xs6>
            <v-btn :color="weekSelected.color" depressed :disabled="conversionPackage.type == 'inactive'" :loading="weekSelected.loading" @click="filterConversionWeek()" style="margin: 0; height: 48px;" block large><span :style="{color: weekSelected.textColor}">Deze week</span></v-btn>
          </v-flex>
          <v-flex md3 xs6>
            <v-btn :color="monthSelected.color" depressed :disabled="conversionPackage.type == 'inactive'" :loading="monthSelected.loading" @click="filterConversionMonth()" style="margin: 0; height: 48px;" block large><span :style="{color: monthSelected.textColor}">Deze maand</span></v-btn>
          </v-flex>
          <v-flex md3 xs6>
            <v-btn :color="periodSelected.color" depressed :disabled="conversionPackage.type == 'inactive'" :loading="periodSelected.loading" @click="filterConversionPeriod()" style="margin: 0; height: 48px;" block large><span :style="{color: periodSelected.textColor}">Selecteer maand</span></v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-if="filterPeriod" row wrap class="ma-0 pa-0">
          <v-flex md3 xs12>
            <v-select
              single-line
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="activeYears"
              label="Selecteer jaar"
              hide-details
              outlined
              v-model="selectedPeriodYear"      
            ></v-select>
          </v-flex>
          <v-flex md6 xs12>
            <v-select
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              :items="months"
              item-text="name"
              item-value="id"
              item-disabled="disabled"
              label="Selecteer maand"
              hide-details
              v-model="selectedPeriodMonth"
              outlined 
            ></v-select>
          </v-flex>
          <v-flex md3 xs12>
            <v-btn @click="loadCustomPeriodFilter(selectedPeriodMonth, selectedPeriodYear, 'filter')" :disabled="filterButtonDisabled" :depressed="filterButtonDisabled" :color="companySecondaryColor" style="margin: 0; height: 55px;" large block><span style="color:#fff;">Filter</span></v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    
    <div v-if="loading" class="blackbox-loader"></div>

    <div v-if="!loading && dataLoading">
      <div class="loading-dots">
        <div class="loading-dots-loader"></div>
        <p class="loading-dots-text"></p>
      </div>
    </div>

    <v-card outlined style="margin: 20px 0" v-if="!loading && !dataLoading" >
      <v-container grid-list-md class="pa-0" fluid>
        <v-layout row wrap class="ma-0 pa-1">
          <v-flex xs12 md3>
            <v-select
              v-if="!loading && branches.length > 2"
              :items="branches"
              :item-color="companyPrimaryColor"
              background-color="background"
              item-text="branchName"
              item-value="id"
              v-model="activeBranch"
              no-data-text="Geen vestigingen gevonden."
              label="Selecteer vestiging"
              outlined
              return-object
              hide-details
              dense>
            </v-select>
          </v-flex>
          <v-flex xs12 md6>
            <div class="conversion-selected-period">
              <div v-if="conversionPeriodStartFormatted && conversionPeriodEndFormatted">
                <p class="ma-0" v-if="conversionPeriodType == 'day'"> <strong>{{ conversionPeriodStartFormatted  }}</strong></p>
                <p class="ma-0" v-else><strong>{{ conversionPeriodStartFormatted }}</strong> t/m <strong>{{ conversionPeriodEndFormatted  }}</strong></p>
              
<!--               
                <p class="ma-0" v-if="conversionPeriodType == 'day'"> <strong>{{ conversionPeriodStart | moment('add','1 days', "D MMMM YYYY") }}</strong></p>
                <p class="ma-0" v-else><strong>{{ conversionPeriodStart | moment('add','1 days', "D MMMM YYYY") }}</strong> t/m <strong>{{ conversionPeriodEnd  | moment('subtract','1 days', "D MMMM YYYY") }}</strong></p>
               -->
              </div>
            </div>
          </v-flex>
          <v-flex xs12 md3>
            <div class="text-center" v-if="conversionPackage.type != 'inactive'">
              <span class="text-center" style="min-width:200px; padding: 4px 10px; font-size: 18px; margin: 10px 0 0 0; display: inline-block; background-color: #E8F5E9;" v-if="liveUpdates"><strong>LIVE</strong> <v-icon color="#251433" size="18px" style="margin: -3px 0 0 10px" v-if="liveUpdatesTimer">timer</v-icon> {{liveUpdatesTimer}} <v-btn icon color="#FF4500" ><v-icon @click="stopLiveUpdates()">stop</v-icon></v-btn></span>
              <v-tooltip bottom v-if="!liveUpdates">
                <template v-slot:activator="{ on }">  
                  <v-btn v-on="on" block class="my-2" outlined :color="companySecondaryColor" @click="checkForNewConversions()">Live weergave</v-btn>
                </template>
                <span class="white--text">Nieuwe pogingen worden gelijk weergegeven op het dashboard.</span>
              </v-tooltip>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container v-if="conversions.length > 0 && conversionPackage.type != 'inactive'" grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-1">
          <v-flex md9 xs6>
            <div>
              <v-select
                class="pa-0 ma-0"
                v-model="selectedSources"
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                :items="sources"
                item-text="name"
                item-value="query"
                label="Selecteer campagne bronnen"
                multiple
                dense
                single-line
                hide-details
                outlined
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip small :color="item.bgColor.hex" v-if="index === 0">
                    <span :style="{ color: item.textColor.hex}">{{ item.name }}</span>
                  </v-chip>
                  <v-chip small :color="item.bgColor.hex" v-if="index === 1">
                    <span :style="{ color: item.textColor.hex}">{{ item.name }}</span>
                  </v-chip>
                  <v-chip small :color="item.bgColor.hex" v-if="index === 2">
                    <span :style="{ color: item.textColor.hex}">{{ item.name }}</span>
                  </v-chip>
                  <v-chip small :color="item.bgColor.hex" v-if="index === 3">
                    <span :style="{ color: item.textColor.hex}">{{ item.name }}</span>
                  </v-chip>
                  <v-chip small :color="item.bgColor.hex" v-if="index === 4">
                    <span :style="{ color: item.textColor.hex}">{{ item.name }}</span>
                  </v-chip>
                  <v-chip small :color="item.bgColor.hex" v-if="index === 5">
                    <span :style="{ color: item.textColor.hex}">{{ item.name }}</span>
                  </v-chip>
                  <span
                    v-if="index === 7"
                    class="grey--text caption"
                  >(+{{ selectedSources.length - 6 }} andere)</span>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @click="toggle"
                  >
                    <v-list-item-action>
                      <v-icon :color="selectedSources.length > 0 ? companyPrimaryColor : ''">{{ icon }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>Selecteer alle tags</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item disabled dense>
                    <v-list-item-icon :color="companyPrimaryColor">
                      <v-icon :color="companyPrimaryColor">attach_money</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content v-if="chooseAllSources">
                      <v-list-item-title>Iemand hier wil alles weten over conversies ;)</v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-content v-else-if="selectSomeSources">
                      <v-list-item-title>Conversie tags: {{ selectedSources.length }}</v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-content v-else>
                      <v-list-item-title>
                        Geen interesse in conversies?
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </template>

                <template v-slot:append-item>
                  <v-divider></v-divider>
                  
                </template>
        
              </v-select>
            </div>
          </v-flex>
          <v-flex md3 xs6>
            <v-btn :disabled="!sourcesFilterChanged" :depressed="!sourcesFilterChanged" :color="companyPrimaryColor" :dark="sourcesFilterChanged"  @click="filterSources()" style="margin: 0; height: 40px;" block>Filter</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      
      <div class="no-conversions" v-if="conversionsFiltered.length == 0">
        <div class="hipster-image" :class="randomHipster"></div>
        <p>Geen conversies gevonden.</p>
      </div>
      <div v-else>
        <v-container class=" ma-0 pa-1" grid-list-md fluid>
          <v-layout row wrap class="ma-0 pa-0">
            <!--  <v-flex xs12>
              <v-card  style="padding: 10px; box-shadow: none; background-color: #f9f9f9;">
                <v-sheet class="ma-0" elevation="0">
                  <v-sparkline
                    :value="conversionTableValues"
                    :labels="conversionTableLabels"

                    line-width="2"
                    :gradient="[companyPrimaryColor, companySecondaryColor]"
                    :color="companyPrimaryColor"
                    stroke-linecap="round"
                    height="100"
                    padding="10"
                    label-size="2"
                  >
              
                  </v-sparkline> 
                </v-sheet>
              </v-card> 
            </v-flex> -->
            <v-flex md2 xs6 d-flex>
              <v-card class="usertype-total" style="width: 100%" outlined color="background">
                <div class="usertype-total-number" :style="{color: $vuetify.theme.themes[theme].text}">{{ conversionsFiltered.length }}</div>
                <div class="usertype-total-desc">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-if="conversions == 1" :style="{color: $vuetify.theme.themes[theme].text}">Intentie <v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>
                      <span v-else :style="{color: $vuetify.theme.themes[theme].text}">Intenties <v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>
                    </template>
                    <span class="white--text">Aantal pogingen die gestart zijn om een conversie te doen.</span>
                  </v-tooltip>     
                </div>
              </v-card>
            </v-flex>
            <v-flex md2 xs6 d-flex>
              <v-card class="usertype-total" style="width: 100%" outlined color="background">
                <div class="usertype-total-number" :style="{color: $vuetify.theme.themes[theme].text}">{{ newClients }} <span style="font-size: 20px;">({{newClientsSuccess}})</span></div>
                <div class="usertype-total-desc">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span :style="{color: $vuetify.theme.themes[theme].text}">Nieuwe klanten (succes)<v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>
                    </template>
                    <span class="white--text">Nieuwe klanten gebasseerd op e-mailadres die opgeslagen zijn in Salonhub. (En welke succesvol zijn afgerond)</span>
                  </v-tooltip>     
                </div>
              </v-card>
            </v-flex>
            <v-flex md2 xs6 d-flex>
              <v-card class="usertype-total" style="width: 100%" outlined color="background">
                <div class="usertype-total-number" :style="{color: $vuetify.theme.themes[theme].text}">{{ conversionsSuccessRate }}%</div>
                <div class="usertype-total-desc">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span :style="{color: $vuetify.theme.themes[theme].text}">Succesvol <v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>   
                    </template>
                    <span class="white--text">Het percentage dat succesvol is afgerond.</span>
                  </v-tooltip>             
                </div>
              </v-card>
            </v-flex>
            <v-flex md2 xs6 d-flex>
              <v-card class="usertype-total" style="width: 100%" outlined color="background">
                <div class="usertype-total-number" :style="{color: $vuetify.theme.themes[theme].text}"> &euro; {{ conversionsValue }}</div>
                <div class="usertype-total-desc">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span :style="{color: $vuetify.theme.themes[theme].text}">Opbrengst<v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>   
                    </template>
                    <span class="white--text">Opbrengst van de conversies in geld</span>
                  </v-tooltip>             
                </div>
              </v-card>
            </v-flex>
            <v-flex md2 xs6 d-flex>
              <v-card class="usertype-total" style="width: 100%" outlined color="background">
                <div class="usertype-total-number" :style="{color: $vuetify.theme.themes[theme].text}">&euro; {{ extraConversionPotential }}</div>
                <div class="usertype-total-desc">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span :style="{color: $vuetify.theme.themes[theme].text}">Openstaand <v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>   
                    </template>
                    <span class="white--text">Potentiele extra opbrengst bij afronden van van alle pogingen</span>
                  </v-tooltip>       
                </div>
              </v-card>
            </v-flex>
            <v-flex md2 xs6 d-flex>
              <v-card class="usertype-total" style="width: 100%" outlined color="background">
                <div class="usertype-total-number" :style="{color: $vuetify.theme.themes[theme].text}">{{ manualConversions.success }}/{{ manualConversions.called }} <span v-if="manualConversions.worth" style="font-size: 16px;">(&euro;{{ manualConversions.worth.toFixed(0) }})</span></div>
                <div class="usertype-total-desc">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span :style="{color: $vuetify.theme.themes[theme].text}">Succesvol teruggebeld <v-icon small :color="$vuetify.theme.themes[theme].text" v-on="on">help</v-icon></span>   
                    </template>
                    <span class="white--text">Succesvolle conversies n.a.v. terugbellen.</span>
                  </v-tooltip>       
                </div>
              </v-card>
            </v-flex>

     
            <v-flex xs12 v-if="messagesSend.number > 0 && (userRole == 'admin' || userRole == 'superadmin')">
              <v-alert
                color="blue-grey"
                icon="mdi-cellphone-message"
                class="pa-2  ma-0"
                dense
                outlined
                >
                Verzonden sms-berichten in geselecteerde periode: <strong>{{ messagesSend.number }}</strong> <span v-if="messagesSend.number > 1"><strong> berichten</strong></span> <span v-else><strong> bericht</strong></span> (&euro;{{ messagesSend.costs }}). <i>Het versturen van sms-bericht kost &euro; {{ pricePerMessageSend }}</i>.  
              </v-alert>
            </v-flex>

            <v-flex xs12 v-if="adWordsCosts && (userRole == 'superadmin' && !demoMode)">
              <v-alert
                type="info"
                class="pa-2  ma-0"
                dense
                outlined
                >
                Het Adwordsbudget is ingesteld op <strong> &euro;{{ activeCompData.conversion.adwordsBudget }}</strong>. Schatting uitgegeven kosten in de geselecteerde periode zijn <strong>&euro; {{adWordsCosts}}</strong>.
              </v-alert>
            </v-flex>

            <v-flex xs12 v-if="(userRole == 'superadmin' && !demoMode)">
              <v-alert
                type="success"
                class="pa-2  ma-0"
                dense
                outlined
                >
                Aantal succesvolle gespreken <strong>{{ hogansConversions.success }}/{{ hogansConversions.called }}</strong>. Totale kosten geselecteerde periode: <strong> &euro;{{ hogansConversions.costs }}</strong>
              </v-alert>
            </v-flex>

            
          </v-layout>
        </v-container>

        <div v-if="selected.length > 0" class="clear" style="padding: 0 10px;">
          <v-btn style="float: right;" fab darken color="primary" @click="removeConversionsDialog = true">
            <v-icon darken>delete</v-icon>
          </v-btn> 
        </div>

        <div v-if="deleting == true">
          <div class="loading-dots">
            <div class="loading-dots-loader"></div>
            <p class="loading-dots-text"> {{ deleteCounter }} van {{ selected.length }} verwijderd. </p>
          </div>
        </div>

        <div v-else>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="conversionsFiltered"
            show-expand
            :sort-desc="true"
            :page.sync="conversionSelectedPage"
            @page-count="conversionSelectorPages"
            hide-default-footer
            :sort-by.sync="tableOptions.sortBy"
            :items-per-page="50"
            :show-select="adminUser"
            :expanded.sync="expanded"
            single-expand

            class="conversion-table"
            >
            <template v-slot:item="{ item, index, isSelected, select, isExpanded, expand  }" >
          
              <tr :key="conversionKey + index">
                <td v-if="userRole == 'superadmin'">
                  <v-icon @click="select(true)" v-if="!isSelected">check_box_outline_blank</v-icon>
                  <v-icon @click="select(false)" v-if="isSelected" >check_box</v-icon>
                </td>
                <td>
                  <div v-if="item.language == 'nl' || item.language == 'NL'" class="language-flag nl"> </div>
                  <div v-else-if="item.language == 'en' || item.language == 'EN'" class="language-flag uk"> </div>
                </td>
                <td>
                  <v-tooltip :disabled="(userRole != 'superadmin') && !demoMode" right style="cursor: pointer;">
                    <template v-slot:activator="{ on }">                           
                      <v-avatar
                        v-on="on"
                        size="32"
                        v-if="item.clientData.device == 'desktop'"
                        :color="$vuetify.theme.themes[theme].background"
                      >
                        <v-icon small :color="$vuetify.theme.themes[theme].text">desktop_windows</v-icon>
                      </v-avatar>
                      <v-avatar
                        v-on="on"
                        size="32"
                        v-else-if="item.clientData.device == 'mobile'"
                        :color="$vuetify.theme.themes[theme].background"
                      >
                        <v-icon small :color="$vuetify.theme.themes[theme].text">phone_iphone</v-icon>
                      </v-avatar>
                      <v-avatar 
                        v-on="on"
                        size="32" 
                        v-else 
                        :color="$vuetify.theme.themes[theme].background"
                        >
                        <span small class="headline" :style="{color: $vuetify.theme.themes[theme].text}">?</span>
                      </v-avatar>
                    </template>
                    <span v-if="item.clientData.userAgent" style="color: #fff"><strong>Device info: </strong>{{ item.clientData.userAgent }} </span>
                    <span v-else style="color: #fff">Geen informatie opgeslagen</span>
                  </v-tooltip> 
                </td>                     
                <td> 
                  <div class="attempt-box"><span>{{ item.attempts }}</span>x</div>
                </td>
                <td>
                  <span v-if="(today - averageConversionTime) <  item.timestampUpdated.seconds">
                    <v-tooltip right :disabled="item.progress.completed">
                      <template v-slot:activator="{ on }">
                        <div style=" cursor: pointer; padding: 5px 0 0 0; font-style: italic; text-align: left;">
                          <span v-if="(today - item.timestamp.seconds) == 1">   
                            {{ (today - item.timestamp.seconds) }} seconde geleden
                          </span>
                          <span v-if="(today - item.timestamp.seconds) > 1 && (today - item.timestamp.seconds) < 60">   
                            {{ (today - item.timestamp.seconds) }} seconden geleden
                          </span>
                          <span v-if="(today - item.timestamp.seconds) > 59 && (today - item.timestamp.seconds) < 120">   
                            {{ Math.floor((today - item.timestamp.seconds) / 60) }} minuut geleden
                          </span>
                          <span v-if="(today - item.timestamp.seconds) > 119" >   
                            {{ Math.floor((today - item.timestamp.seconds) / 60) }} minuten geleden
                          </span>
                          <v-icon v-if="!item.progress.completed" small color="#333" v-on="on">help</v-icon>
                        </div>   
                      </template>
                      <span style="color: #fff">Klant kan nog bezig zijn met deze conversie.</span>
                    </v-tooltip>
                  </span>
                  <span v-else>{{ item.timestamp.seconds | moment("D MMM - H:mm")}}u</span>
                </td>
                <td>
                  <v-chip color="#eee" dense small :disabled="item.timestampUnix <= twoWeeksAgoUnix" style="min-width: 70px;">
                    <v-icon left v-if="item.salonhubData && !item.salonhubData.existingClient" small color="#333">star</v-icon>
                    <span v-if="item.timestampUnix > twoWeeksAgoUnix"> {{ item.clientData.name }}</span>
                  </v-chip>
                </td>
                <td>
                  <span v-for="(type, index) in types" :key="index">
                    <v-chip small v-if="item.type == type.id" :color="type.color" :outlined="type.outlined">{{ type.name }}</v-chip>
                  </span>
                </td>
                <td>
                  <span v-if="item.salonhubData && item.salonhubData.branch">{{ branchNames[item.salonhubData.branch] }}</span>
                </td>
                <td>
                  <span v-if="item.source && conversionPackage.type != 'inactive'">
                    <v-tooltip right :disabled="!item.originalSource" style="cursor: pointer;">
                      <template v-slot:activator="{ on }">                                             
                        <span v-for="(source, index) in sources" :key="index">
                          <v-chip small :color="source.bgColor.hex" v-if="item.source == source.query"><span :style="{color: source.textColor.hex}">{{source.name}}</span></v-chip>
                        </span>  
                        <v-icon small color="#333"  v-if="item.originalSource" v-on="on">help</v-icon>
                      </template>
                      <span style="color: #fff">Gebruikte bron: src?={{ item.originalSource }}</span>
                    </v-tooltip>
                  </span>
                  <span v-if="item.source && conversionPackage.type == 'inactive'">
                    <v-chip small color="#ccc" ><span style="#333">Onbekend</span></v-chip>
                  </span>
                </td>              
                <td>
                  <span v-if="item.value"> 
                    <span v-if="item.value.type == 'amount' && item.value.number > 0"> &euro; {{ item.value.number }} </span>
                    <span v-else-if="item.value.type != 'amount' && item.value.number > 0"> {{ item.value.number }} </span>
                    <span v-else>-</span>
                  </span>
                </td>
                <td>
                  <span v-if="!item.progress.availableForAction && item.progress.completed && item.progress.completedBy == 'user'" style="padding: 3px; display: block; width: 60px; text-align: center; background-color: #8bc34a;">Ja</span>
                  <span v-else-if="!item.progress.availableForAction && item.progress.completed && item.progress.completedBy != 'user' && item.progress.completedBy != 'clientOtherWay'"> <span style="padding: 3px; margin: 0 3px 0 0; display: inline-block; width: 60px; text-align: center; background-color: #8bc34a;">Ja</span><v-icon small color="text">perm_phone_msg</v-icon></span> 
                  <span v-else-if="item.progress.availableForAction && item.progress.onHold"> <span style="padding: 5px; margin: 0 3px 0 0; background-color: #64B5F6; display: inline-block; width: 60px; text-align: center;">Bezig</span> <v-icon small color="text">perm_phone_msg</v-icon></span>
                  <span v-else-if="item.progress.availableForAction && !item.progress.completed"  style="padding: 5px; background-color: #fb8c00; display: block; width: 60px; text-align: center;">Nee</span>
                  <span v-else-if="!item.progress.availableForAction && !item.progress.completed && item.progress.noSuccessReason == 'otherwiseSuccesfull'"> <span style="padding: 3px; margin: 0 3px 0 0; display: inline-block; width: 60px; text-align: center; background-color: #8bc34a;">Ja</span><v-icon small color="text">perm_phone_msg</v-icon></span> </span>
                  <span v-else-if="!item.progress.availableForAction && !item.progress.completed"> <span style="padding: 5px; margin: 0 3px 0 0; background-color: #ff5252; display: inline-block; width: 60px; text-align: center;">Nee</span> <v-icon small color="text">perm_phone_msg</v-icon></span>
                  <span v-else-if="!item.progress.availableForAction && item.progress.completed && item.progress.completedBy == 'clientOtherWay'" ><span style="padding: 3px; margin: 0 3px 0 0; display: inline-block; width: 60px; text-align: center; background-color: #8bc34a;">Ja</span><v-icon dense color="text">mdi-account-arrow-left</v-icon></span> 
                </td>
                <td class="text-center" style="font-size: 12px;">
                   <v-tooltip left v-if="item.progress.callMe || item.clusterCallMe" style="cursor: pointer;">
                    <template v-slot:activator="{ on }">
                      <v-icon  v-on="on"  color="success" >mdi-card-account-phone</v-icon>                                             
                    </template>
                    <span style="color: #fff">Klant wil graag gebeld worden voor hulp.</span>
                  </v-tooltip>

                  <v-tooltip left v-if="item.smsSend || item.clusterSmsSend" style="cursor: pointer;">
                    <template v-slot:activator="{ on }">
                      <v-icon  v-on="on"  color="text" >mdi-cellphone-message</v-icon>                                             
                    </template>
                    <span style="color: #fff">Sms verzonden naar de klant.</span>
                  </v-tooltip>

                  <v-tooltip left v-if="item.salonhubData && item.salonhubData.closeReason || item.clusterCloseReason" style="cursor: pointer;">
                    <template v-slot:activator="{ on }">
                      <v-icon  v-on="on"  color="text">mdi-message-text</v-icon>                                             
                    </template>
                    <span style="color: #fff">Klant heeft feedback achtergelaten bij sluiten van widget</span>
                  </v-tooltip>

                  <v-tooltip left v-if="(((today - item.timestampUnix)/60).toFixed(0) <= 20)" style="cursor: pointer;">
                    <template v-slot:activator="{ on }">
                      <v-icon  v-on="on"  color="red" >mdi-fire</v-icon>                                             
                    </template>
                    <span style="color: #fff">Het perfecte moment om de klant hulp te bieden.</span>
                  </v-tooltip>
                    
                  <div v-if="((userRole == 'superadmin' && !demoMode) || userOperator) && (item.progress.availableForAction && !item.progress.completed && !item.progress.onHold)" style="display: inline-block">
                    <v-icon v-if="(((today - item.timestampUnix)/60).toFixed(0) > 20 && ((today - item.timestampUnix)/60).toFixed(0) <= 60)" color="warning" >mdi-timer-outline</v-icon>
                    <v-icon v-if="(((today - item.timestampUnix)/60).toFixed(0) > 60)" color="warning" >mdi-emoticon-sad-outline</v-icon>                                              
                  </div>

                  <!-- <v-tooltip left v-if="checkForBlacklist(item.clientData.phone) == true" style="cursor: pointer;">
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="red" >mdi-close-circle</v-icon>                                        
                    </template>
                    <span style="color: #fff">Klant wilt niet gebeld worden</span>
                  </v-tooltip> -->


                  <div v-if="item.progress.completedOn && ((userRole == 'superadmin' && !demoMode) || userOperator) && ((!item.progress.availableForAction && item.progress.completed && item.progress.completedBy != 'user') || (item.progress.availableForAction && item.progress.onHold) || (!item.progress.availableForAction && !item.progress.completed && item.progress.noSuccessReason == 'otherwiseSuccesfull') || (!item.progress.availableForAction && !item.progress.completed))">
                    <div v-if="((item.progress.completedOn.seconds - item.timestampUnix)/60).toFixed(0) <= 60">
                      <v-icon v-if="((item.progress.completedOn.seconds -  item.timestampUnix)/60).toFixed(0) <= 15" color="red" >mdi-fire</v-icon>
                      <v-icon v-else color="warning" >mdi-timer-outline</v-icon><br>
                      {{ ((item.progress.completedOn.seconds -  item.timestampUnix)/60).toFixed(0) }} min 
                    </div>
                    <div v-else >
                      <v-icon color="red" >mdi-emoticon-sad-outline</v-icon><br>
                      {{ (((item.progress.completedOn.seconds -  item.timestampUnix)/60)/60).toFixed(1) }} uur
                    </div>
                    
                  </div> 
                </td>
                <td>
                  <div v-if="item.salonhubData && item.salonhubData.completedByBackend && !item.salonhubData.completedByBackend.completed && item.salonhubData.completedByBackend.failedReason"> 
                  <v-tooltip left style="cursor: pointer;">
                      <template v-slot:activator="{ on }">                           
                        <v-icon small color="error" v-on="on">error_outline</v-icon>
                      </template>
                      <span style="color: #fff"><strong>DocId:</strong> {{ item.id }} <strong>Error:</strong> {{ item.salonhubData.completedByBackend.failedReason }} </span>
                    </v-tooltip> 
                  </div>
                </td>
                <td>
                  <div v-if="item.timestampUnix > twoWeeksAgoUnix">           
                    <v-btn icon @click="expand(true), checkForBlacklist(item), collapsedClient = item, checkBusyStatus(item.progress.onHold, item.progress.noSuccessReason)" v-if="!isExpanded && conversionPackage.type != 'inactive'"><v-icon dark>expand_more</v-icon></v-btn>
                    <v-btn icon @click="expand(false)" v-if="isExpanded && conversionPackage.type != 'inactive'"><v-icon dark>expand_less</v-icon></v-btn>
                  </div>
                </td>
              </tr>          
            </template>

            <template v-slot:expanded-item="{ headers, item, index }">
              <td :colspan="headers.length" style="padding: 0!important;">
              <v-card  flat :style="{backgroundColor: $vuetify.theme.themes[theme].menuhover, borderColor: $vuetify.theme.themes[theme].menuborder}" style="border-bottom: 1px solid;">
                <v-card-text>
                  <v-container class="extra-conversion-info ma-0 pa-0" grid-list-md fluid>
                    <v-layout row wrap class="ma-0 pa-0">
                      <v-flex md4 xs6>
                        <div class="conversion-client-info clear">
                          <h3 style="font-weight: bold;">Contactgegevens</h3>
                          <div><span class="info-label">Naam:</span> <span class="info-data" v-if="item.clientData.name"> {{ item.clientData.name }}</span><span class="info-data" v-else> - </span></div>
                          <div v-if="!item.blacklisted.status"><span class="info-label">Telefoon:</span> <span class="info-data"  v-if="item.clientData.phone">{{ item.clientData.phone }}</span><span class="info-data"  v-else> - </span></div>
                          <div><span class="info-label">Email:</span> <span class="info-data"  v-if="item.clientData.email">{{ item.clientData.email }}</span><span class="info-data" v-else> - </span></div>
                          <div v-if="item.startUrl"><span class="info-label">Start url:</span> <span class="info-data" >{{ item.startUrl }}</span></div>

                          <div v-if="(userRole == 'superadmin' && !demoMode)"><span class="info-label">IP-adres:</span> <span class="info-data"  v-if="item.clientData.ip && item.clientData.ip.query">{{ item.clientData.ip.query }}</span><span class="info-data" v-else> - </span></div>
                        </div>

                        <div>
                          <div v-if="item.progress.callMe" style=" margin: 5px 0; padding: 5px; border-radius: 3px; background-color: #4caf50; display: inline-block">
                            <v-icon  color="menu" >mdi-card-account-phone</v-icon>                                             
                            <span class="px-2" style="color: #fff">Klant wil graag gebeld worden voor hulp.</span>
                          </div>
                        </div>

                        <div v-if="item.smsSend" style=" margin: 5px 0; padding: 5px; border-radius: 3px;">
                          <v-icon  color="text" >mdi-cellphone-message</v-icon>                                             
                          <span class="px-2">Sms verzonden naar de klant.</span>
                        </div>

                        <div>
                          <div v-if="item.salonhubData && item.salonhubData.closeReason" style=" margin: 5px 0; padding: 5px; border-radius: 3px; display: inline-block" :style="{backgroundColor: $vuetify.theme.themes[theme].text}">
                            <v-icon  color="menu" >mdi-message-text</v-icon>
                            <span class="px-2" :style="{color: $vuetify.theme.themes[theme].menu}">
                              <strong>Feedback: </strong>
                                <span :style="{color: $vuetify.theme.themes[theme].menu}" v-if="item.salonhubData.closeReason == 'noSpaceFound'">Ik kan geen geschikte tijd vinden.</span>
                                <span :style="{color: $vuetify.theme.themes[theme].menu}" v-else-if="item.salonhubData.closeReason == 'restartingWidget'">Ik wil de widget opnieuw starten.</span>
                                <span :style="{color: $vuetify.theme.themes[theme].menu}" v-else-if="item.salonhubData.closeReason == 'widgetError'">Widget werkt niet goed.</span>
                                <span :style="{color: $vuetify.theme.themes[theme].menu}" v-else>{{ item.salonhubData.closeReason }}</span>
                            </span>                                             
                          </div>
                        </div>
                        <div v-if="item.blacklisted.status">
                          <v-alert class="my-3" type="error" dark dense >
                            <span style="color: white">Klant wilt niet gebeld worden.</span>
                          </v-alert>
                          <p>{{ item.blacklisted.comment}}</p>
                        </div>
                        
                        
                        <v-btn v-if="!item.blacklisted.status" @click="newBlacklist.phone = item.clientData.phone, newBlacklist.dialog = true" class="mt-4" color="red" dark small >Telefoon toevoegen aan <strong>Bel Mij Niet lijst</strong></v-btn>
                      </v-flex>
                      <v-flex md4 xs6>
                        <div v-if="item.type == 'salonhub'" class="conversion-client-info">
                          <h3 style="font-weight: bold;">Afspraak gegevens</h3>
                          <div v-if="!item.progress.availableForAction" class="info-wrapper">
                            <div><span class="info-label">Nieuwe klant:</span> <span class="info-data" v-if="item.salonhubData.existingClient == true">Nee</span><span v-else-if="item.salonhubData.existingClient == false">Ja <v-icon color="warning" small>warning</v-icon></span><span class="info-data" v-else> - </span></div>                            
                            <div><span class="info-label">Vestiging:</span> <span class="info-data" v-if="item.salonhubData.branch">{{ item.salonhubData.branchName }}</span><span class="info-data"  v-else> - </span></div>
                            <div><span class="info-label">Datum:</span> <span class="info-data" v-if="item.salonhubData.steps && item.salonhubData.steps.date">{{ item.salonhubData.steps.date | moment("D MMMM YYYY") }}</span><span class="info-data"  v-else> - </span></div>
                            <div><span class="info-label">Tijd:</span> <span class="info-data" v-if="item.salonhubData.steps && item.salonhubData.steps.time">{{ item.salonhubData.steps.time }}</span><span class="info-data"  v-else> - </span></div>
                            <div><span class="info-label">Geslacht:</span> <span class="info-data" v-if="item.salonhubData.steps && item.salonhubData.steps.gender && item.salonhubData.steps.gender.name">{{ item.salonhubData.steps.gender.name }}</span><span class="info-data"  v-else> - </span></div>
                            <div><span class="info-label">Behandeling:</span> <span class="info-data" v-if="item.salonhubData.steps && item.salonhubData.steps.treatment && item.salonhubData.steps.treatment.name">{{ item.salonhubData.steps.treatment.name }}</span><span class="info-data"  v-else> - </span></div>
                            <div><span class="info-label">Medewerker:</span> <span class="info-data" v-if="item.salonhubData.steps && item.salonhubData.steps.employee && item.salonhubData.steps.employee.name">{{ item.salonhubData.steps.employee.name }}</span><span class="info-data"  v-else> - </span></div>
                            <div><span class="info-label">Duur afspraak maken:</span> <span class="info-data" v-if="item.timestamp.seconds != item.timestampUpdated.seconds">{{ Math.ceil((item.timestampUpdated.seconds - item.timestamp.seconds) / 60) }} <span v-if="Math.ceil((item.timestampUpdated.seconds - item.timestamp.seconds) / 60) == 1">minuut</span><span v-else>minuten</span></span><span class="info-data"  v-else> - </span></div>
                          </div>
                          <div v-else style="padding: 0 15px 0 0;">
                            <div class="close-conversion-buttons" style="margin: 0 0 10px 0;">
                              <div class="close-conversion-button left" :class="{'active': closeConversionSuccessfull == true}" @click="closeConversionSuccessfull = true, closeConversionReason = null">Afmaken</div>
                              <div class="close-conversion-button middle" :class="{'active': closeConversionSuccessfull == 'wait'}" @click="closeConversionSuccessfull = 'wait', checkBusyStatus(item.progress.onHold, item.progress.noSuccessReason)">Bezig</div>
                              <div class="close-conversion-button right" :class="{'active': closeConversionSuccessfull == false}" @click="closeConversionSuccessfull = false, closeConversionReason = null">Afsluiten</div>
                            </div>
                            <div v-if="closeConversionSuccessfull == true">
                              <p style="padding: 5px 0; font-size: 16px; margin: 0;">Conversie afmaken na contact met de klant.</p>
                              <v-container  grid-list-md fluid class="ma-0 pa-0">
                                <v-alert
                                  v-if="conversionSalonhubfeedback"
                                  class="ma-0 pa-2"
                                  :value="true"
                                  type="warning"
                                >
                                  {{conversionSalonhubfeedback}}
                                </v-alert>

                                <v-alert
                                  v-if="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                  class="ma-0 pa-2"
                                  :value="true"
                                  type="info"
                                >
                                  Klant is nog bezig met invullen van formulier. Laatste wijziging is 
                                  <span v-if="(today - item.timestampUpdated.seconds) == 1">   
                                    {{ (today - item.timestampUpdated.seconds) }} seconde geleden.
                                  </span>
                                  <span v-if="(today - item.timestamp.seconds) > 1 && (today - item.timestampUpdated.seconds) < 60">   
                                    {{ (today - item.timestampUpdated.seconds) }} seconden geleden.
                                  </span>
                                  <span v-if="(today - item.timestampUpdated.seconds) >= 60 && (today - item.timestampUpdated.seconds) < 120">   
                                    {{ Math.floor((today - item.timestampUpdated.seconds) / 60) }} minuut geleden.
                                  </span>
                                  <span v-if="(today - item.timestampUpdated.seconds) > 119" >   
                                    {{ Math.floor((today - item.timestampUpdated.seconds) / 60) }} minuten geleden.
                                  </span>
                                </v-alert>
                                <v-layout row wrap>
                                  <v-flex xs12 md6>
                                    <v-select
                                      class="my-1 pa-0"
                                      style="background-color: #fff;"
                                      hide-details
                                      :items="clientType"
                                      item-text="name"
                                      item-value="id"
                                      :readonly="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      :disabled="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      v-model="item.salonhubData.existingClient"
                                      label="Nieuwe klant"
                                      outlined
                                      dense>
                                    </v-select>
                                  </v-flex>
                                  <v-flex xs12 md6>
                                    <v-select
                                      class="my-1 pa-0"
                                      style="background-color: #fff;"
                                      hide-details
                                      :items="genders"
                                      v-model="item.salonhubData.steps.gender.name"
                                      :readonly="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      :disabled="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      label="Geslacht"
                                      outlined
                                      dense>
                                    </v-select>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-text-field
                                      class="my-1 pa-0"
                                      style="background-color: #fff;"
                                      hide-details
                                      v-model="item.salonhubData.branchName"
                                      :readonly="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      :disabled="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      label="Vestiging"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12 md6>
                                    <v-menu
                                      :close-on-content-click="false"
                                      v-model="appointmentDateDialog"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      :disabled="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      max-width="290px"
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-if="item.salonhubData.steps.date "
                                          class="my-1 pa-0"
                                          style="background-color: #fff;"
                                          v-on="on"
                                          :value="item.salonhubData.steps.date | moment('D MMMM YYYY')"
                                          label="Datum"
                                          readonly
                                          :disabled="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                          hide-details
                                          outlined
                                          dense
                                        ></v-text-field>
                                        <v-text-field
                                          v-else
                                          class="my-1 pa-0"
                                          style="background-color: #fff;"
                                          v-on="on"
                                          value=""
                                          label="Datum"
                                          readonly
                                          :disabled="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                          hide-details
                                          outlined
                                          dense
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="item.salonhubData.steps.date"
                                        no-title
                                        :min="now"
                                        color="primary"
                                        @input="appointmentDateDialog = false"
                                      ></v-date-picker>
                                    </v-menu>
                                  </v-flex>
                                  <v-flex xs12 md6>
                                    <v-text-field
                                      class="my-1 pa-0"
                                      style="background-color: #fff;"
                                      hide-details
                                      :readonly="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      :disabled="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      type="time"
                                      label="Tijd"
                                      v-model="item.salonhubData.steps.time"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-text-field
                                      class="my-1 pa-0"
                                      style="background-color: #fff;"
                                      hide-details
                                      :readonly="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      :disabled="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      label="Behandeling"
                                      v-model="item.salonhubData.steps.treatment.name"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-text-field
                                      class="my-1 pa-0"
                                      style="background-color: #fff;"
                                      hide-details
                                      label="Medewerker"
                                      height="48px"
                                      :readonly="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      :disabled="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      v-model="item.salonhubData.steps.employee.name"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-text-field
                                      class="my-1 pa-0"
                                      style="background-color: #fff;"
                                      hide-details
                                      label="Bedrag"
                                      prefix="€"
                                      type="number"
                                      :readonly="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      :disabled="(today - averageConversionTime) <  item.timestampUpdated.seconds"
                                      v-model.number="item.value.number"
                                      outlined
                                      dense
                                    ></v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <div style="padding: 10px 0 0 0;">
                                      <v-btn 
                                        class="ma-0"
                                        block 
                                        large 
                                        :dark="(today - averageConversionTime) >=  item.timestampUpdated.seconds"
                                        :depressed="(today - averageConversionTime) <  item.timestampUpdated.seconds" 
                                        :disabled="(today - averageConversionTime) <  item.timestampUpdated.seconds" 
                                        @click="updateConversionSuccess(item, index)"
                                        :color="companyPrimaryColor"
                                        >
                                        Succesvol afronden
                                      </v-btn> 
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                          <div style="cursor: pointer; padding: 5px 0 0 0; font-style: italic; text-align: center;">Meer informatie <v-icon small color="#ccc" v-on="on">help</v-icon></div>   
                                        </template>
                                        <span style="color: #fff">Conversie handmatig succesvol afronden. Bijvoorbeeld na terugbellen.</span>
                                      </v-tooltip>
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </div>
                            <div v-else-if="closeConversionSuccessfull == 'wait'">
                              <p style="padding: 5px 0; font-size: 16px; margin: 0;">Wachten met afsluiten conversie na contact met de klant.</p>

                              <v-container  grid-list-md fluid class="ma-0 pa-0">
                                <p><i>Selecteer de reden waarom deze conversie nog niet kan worden afgemaakt.</i></p>
                                <v-flex xs12>
                                  <v-radio-group v-model="closeConversionReason"  hide-details>
                                    <v-radio value="tryAgain" :color="companyPrimaryColor">
                                      <template v-slot:label>
                                        <div>Klant probeert het later nog een keer zelf.</div>
                                      </template>
                                    </v-radio>
                                    <v-radio value="notReachable" :color="companyPrimaryColor">
                                      <template v-slot:label>
                                        <div>Klant niet bereikbaar</div>
                                      </template>
                                    </v-radio>
                                    <v-radio value="otherReasonWait" :color="companyPrimaryColor">
                                      <template v-slot:label>
                                        <div>Anders...</div>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>

                                  <v-text-field
                                    v-if=" closeConversionReason == 'otherReasonWait'"
                                    label="Reden"
                                    style="background-color: #fff; margin: 15px 0 0 0;"
                                    hide-details
                                    v-model="closeConversionReasonOtherWait"
                                    outlined
                                    height="48px"
                                  ></v-text-field>

                                </v-flex>
                                <v-flex xs12>
                                    <div style="padding: 10px 0 0 0;">
                                      <v-btn block large @click="updateConversionWait(item, index)" class="ma-0" :color="companyPrimaryColor" dark>Wachten met afsluiten</v-btn> 
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                          <div style=" cursor: pointer; padding: 5px 0 0 0; font-style: italic; text-align: center;">Meer informatie <v-icon small color="#ccc" v-on="on">help</v-icon></div>   
                                        </template>
                                        <span style="color: #fff">Afspraak kan nog niet afgerond worden. Dit kan eventueel later</span>
                                      </v-tooltip>
                                    </div>
                                  </v-flex>
                              </v-container>
                            </div>
                            <div v-else>
                              <p style="padding: 5px 0; font-size: 16px; margin: 0;">Conversie aflsluiten na contact met de klant.</p>

                              <v-container  grid-list-md fluid class="ma-0 pa-0">
                                <p><i>Selecteer de reden waarom deze conversie niet kan worden afgemaakt.</i></p>
                                <v-flex xs12>
                                  <v-radio-group v-model="closeConversionReason"  hide-details>
                                    <v-radio value="otherwiseSuccesfull" :color="companyPrimaryColor">
                                      <template v-slot:label>
                                        <div>Afspraak is al op een andere manier gemaakt</div>
                                      </template>
                                    </v-radio>
                                    <v-radio value="noDeal" :color="companyPrimaryColor">
                                      <template v-slot:label>
                                        <div>Klant heeft een andere partij gevonden</div>
                                      </template>
                                    </v-radio>
                                    <v-radio value="otherReason" :color="companyPrimaryColor">
                                      <template v-slot:label>
                                        <div>Anders...</div>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>

                                  <v-text-field
                                    v-if=" closeConversionReason== 'otherReason'"
                                    label="Reden"
                                    style="background-color: #fff; margin: 15px 0 0 0;"
                                    hide-details
                                    v-model="closeConversionReasonOther"
                                    outlined
                                    height="48px"
                                  ></v-text-field>

                                
                                </v-flex>
                                <v-flex xs12>
                                    <div style="padding: 10px 0 0 0;">
                                      <v-btn block large @click="updateConversionNoSuccess(item, index)" class="ma-0" :color="companyPrimaryColor" dark>Zonder succes afsluiten</v-btn> 
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                          <div style=" cursor: pointer; padding: 5px 0 0 0; font-style: italic; text-align: center;">Meer informatie <v-icon small color="#ccc" v-on="on">help</v-icon></div>   
                                        </template>
                                        <span style="color: #fff">Conversie zonder success afsluiten. Afspraak kan niet afgerond worden.</span>
                                      </v-tooltip>
                                    </div>
                                  </v-flex>
                              </v-container>
                            </div>
                            
                          </div>

                        </div>

                        <div v-if="item.type == 'chatbotLandbot'" class="conversion-client-info">
                          <h3 style="font-weight: bold;">Chatbot gegevens</h3>
                          <div v-if="!item.progress.availableForAction" class="info-wrapper">
                            <div><span class="info-label">Flow:</span> <span class="info-data" v-if="item.chatbotData && item.chatbotData.chatFlowName">{{ item.chatbotData.chatFlowName }}</span><span class="info-data" v-else> - </span></div> 
                            <div><span class="info-label">Onderwerp:</span> <span class="info-data" v-if="item.chatbotData && item.chatbotData.subject">{{ item.chatbotData.subject }}</span><span class="info-data"  v-else> - </span></div>
                            <div><span class="info-label">Vraag:</span> <span class="info-data" v-if="item.chatbotData && item.chatbotData.question">{{ item.chatbotData.question }}</span><span class="info-data"  v-else> - </span></div>
                          </div>
                          <div v-else style="padding: 0 15px 0 0;">
                            <div class="close-conversion-buttons" style="margin: 0 0 10px 0;">
                              <div class="close-conversion-button left" :class="{'active': closeConversionSuccessfull == true}" @click="closeConversionSuccessfull = true, closeConversionReason = null">Afmaken</div>
                              <div class="close-conversion-button middle" :class="{'active': closeConversionSuccessfull == 'wait'}" @click="closeConversionSuccessfull = 'wait', checkBusyStatus(item.progress.onHold, item.progress.noSuccessReason)">Bezig</div>
                              <div class="close-conversion-button right" :class="{'active': closeConversionSuccessfull == false}" @click="closeConversionSuccessfull = false, closeConversionReason = null">Afsluiten</div>
                            </div>
                            <div v-if="closeConversionSuccessfull == true">
                              <div class="info-wrapper">
                                <div><span class="info-label">Flow:</span> <span class="info-data" v-if="item.chatbotData && item.chatbotData.chatFlowName">{{ item.chatbotData.chatFlowName }}</span><span class="info-data" v-else> - </span></div> 
                                <div><span class="info-label">Onderwerp:</span> <span class="info-data" v-if="item.chatbotData && item.chatbotData.subject">{{ item.chatbotData.subject }}</span><span class="info-data"  v-else> - </span></div>
                                <div class="clear"></div>
                                <v-textarea
                                  class="mt-4"
                                  label="Vraag"
                                  background-color="menu"
                                  hide-details
                                  v-model="item.chatbotData.question"
                                  outlined
                                  rows="4"
                                ></v-textarea>
                              
                              </div>

                              <v-btn  
                                class="ma-0 mt-4"
                                block 
                                large 
                                dark
                                @click="updateConversionChatbotSuccess(item, index)"
                                :color="companyPrimaryColor"
                                >
                                Succesvol afronden
                              </v-btn> 
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <div style="cursor: pointer; padding: 5px 0 0 0; font-style: italic; text-align: center;">Meer informatie <v-icon small color="#ccc" v-on="on">help</v-icon></div>   
                                </template>
                                <span style="color: #fff">Conversie handmatig succesvol afronden. Bijvoorbeeld na terugbellen.</span>
                              </v-tooltip>
                            </div>
                            <div v-else-if="closeConversionSuccessfull == 'wait'">
                              <p style="padding: 5px 0; font-size: 16px; margin: 0;">Wachten met afsluiten conversie na contact met de klant.</p>

                              <v-container  grid-list-md fluid class="ma-0 pa-0">
                                <p><i>Selecteer de reden waarom deze conversie nog niet kan worden afgemaakt.</i></p>
                                <v-flex xs12>
                                  <v-radio-group v-model="closeConversionReason"  hide-details>
                                    <v-radio value="notReachable" :color="companyPrimaryColor">
                                      <template v-slot:label>
                                        <div>Klant niet bereikbaar</div>
                                      </template>
                                    </v-radio>
                                    <v-radio value="otherReasonWait" :color="companyPrimaryColor">
                                      <template v-slot:label>
                                        <div>Anders...</div>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>

                                  <v-text-field
                                    v-if=" closeConversionReason == 'otherReasonWait'"
                                    label="Reden"
                                    style="background-color: #fff; margin: 15px 0 0 0;"
                                    hide-details
                                    v-model="closeConversionReasonOtherWait"
                                    outlined
                                    height="48px"
                                  ></v-text-field>

                                </v-flex>
                                <v-flex xs12>
                                    <div style="padding: 10px 0 0 0;">
                                      <v-btn block large @click="updateConversionWait(item, index)" class="ma-0" :color="companyPrimaryColor" dark>Wachten met afsluiten</v-btn> 
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                          <div style=" cursor: pointer; padding: 5px 0 0 0; font-style: italic; text-align: center;">Meer informatie <v-icon small color="#ccc" v-on="on">help</v-icon></div>   
                                        </template>
                                        <span style="color: #fff">Afspraak kan nog niet afgerond worden. Dit kan eventueel later</span>
                                      </v-tooltip>
                                    </div>
                                  </v-flex>
                              </v-container>
                            </div>
                            <div v-else>
                              <p style="padding: 5px 0; font-size: 16px; margin: 0;">Conversie aflsluiten na contact met de klant.</p>

                              <v-container  grid-list-md fluid class="ma-0 pa-0">
                                <p><i>Selecteer de reden waarom deze conversie niet kan worden afgemaakt.</i></p>
                                <v-flex xs12>
                                  <v-radio-group v-model="closeConversionReason"  hide-details>
                                    <v-radio value="otherwiseSuccesfull" :color="companyPrimaryColor">
                                      <template v-slot:label>
                                        <div>Afspraak is al op een andere manier gemaakt</div>
                                      </template>
                                    </v-radio>
                                    <v-radio value="noDeal" :color="companyPrimaryColor">
                                      <template v-slot:label>
                                        <div>Klant heeft een andere partij gevonden</div>
                                      </template>
                                    </v-radio>
                                    <v-radio value="otherReason" :color="companyPrimaryColor">
                                      <template v-slot:label>
                                        <div>Anders...</div>
                                      </template>
                                    </v-radio>
                                  </v-radio-group>

                                  <v-text-field
                                    v-if=" closeConversionReason== 'otherReason'"
                                    label="Reden"
                                    style="background-color: #fff; margin: 15px 0 0 0;"
                                    hide-details
                                    v-model="closeConversionReasonOther"
                                    outlined
                                    height="48px"
                                  ></v-text-field>

                                
                                </v-flex>
                                <v-flex xs12>
                                    <div style="padding: 10px 0 0 0;">
                                      <v-btn block large @click="updateConversionNoSuccess(item, index)" class="ma-0" :color="companyPrimaryColor" dark>Zonder succes afsluiten</v-btn> 
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                          <div style=" cursor: pointer; padding: 5px 0 0 0; font-style: italic; text-align: center;">Meer informatie <v-icon small color="#ccc" v-on="on">help</v-icon></div>   
                                        </template>
                                        <span style="color: #fff">Conversie zonder success afsluiten. Afspraak kan niet afgerond worden.</span>
                                      </v-tooltip>
                                    </div>
                                  </v-flex>
                              </v-container>
                            </div>
                          </div>
                        </div>

                        <div v-if="item.type == 'wordpressForm' && item.wordpressData" class="conversion-client-info">
                          <h3 style="font-weight: bold;">Formulier gegevens</h3>
                          <div class="info-wrapper">
                          <div><span class="info-label">Formulier:</span> <span class="info-data"  v-if="item.wordpressData.formName">{{ item.wordpressData.formName }}</span><span class="info-data" v-else> - </span></div>                      
                          <div><span class="info-label">Onderwerp:</span> <span class="info-data" v-if="item.wordpressData.subject">{{ item.wordpressData.subject }}</span><span class="info-data"  v-else> - </span></div>
                          <div><span class="info-label">Bericht:</span> <span class="info-data" v-if="item.wordpressData.message">{{ item.wordpressData.message }}</span><span class="info-data"  v-else> - </span></div>
                          </div>
                        </div>

                      </v-flex>
                      <v-flex md4 xs6>
                        <div class="conversion-client-info">
                          <h3 style="font-weight: bold;">Voortgang</h3>
                          <p style="margin: 0" v-if="item.progress.completed"><span class="info-label">Succes: </span>Ja</p>
                          <p style="margin: 0" v-if="!item.progress.completed"><span class="info-label">Succes: </span>Nee</p>
                          <p style="margin: 0" ><span class="info-label">Afgerond door:</span>
                            <span v-if="!item.progress.availableForAction && item.progress.completedBy == 'user'">Klant</span>
                            <span v-if="!item.progress.availableForAction && item.progress.completedBy == 'clientOtherWay'">Klant (op een andere manier)</span>
                            <span v-else-if="!item.progress.availableForAction && item.progress.completedBy != 'user'">{{ item.progress.completedBy }} </span>
                            <span v-else> - </span>
                          </p>
                          <p style="margin: 0" ><span class="info-label">Afgerond op:</span> <span v-if="!item.progress.availableForAction && item.progress.completedOn">{{ item.progress.completedOn.seconds | moment("D MMMM YYYY - H:mm") }}u</span> <span v-else> - </span></p>
                          <p style="margin: 0" v-if="!item.progress.availableForAction && !item.progress.completed">
                            <span class="info-label">Reden geen succes:</span> <span v-if="!item.progress.availableForAction && item.progress.noSuccessReason">
                            <span v-if="item.progress.noSuccessReason == 'notReachable'">Klant is niet bereikbaar.</span>
                            <span v-else-if="item.progress.noSuccessReason == 'otherwiseSuccesfull'">Klant heeft al op een andere manier een afspraak gemaakt.</span>
                            <span v-else-if="item.progress.noSuccessReason == 'noDeal'">Klant heeft een andere partij gevonden.</span>
                            <span v-else>{{ item.progress.noSuccessReason}}</span>
                            </span> 
                            <span v-else> - </span>
                          </p>
                          
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-row v-if="item.images && item.images.length > 0" class="ma-0 pa-0">
                    <h2 style="display: block; width: 100%;" class="mt-4">Afbeeldingen toegevoegd door {{ item.clientData.name }} </h2>
                    <v-col
                      v-for="(image, index) in item.images" :key="index"
                      class="d-flex child-flex"
                      cols="4"
                      >
                      <v-card flat style="max-width:350px" class="pa-2 ma-0">
                        <v-img :src="image"></v-img> 
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-container class="extra-conversion-info ma-0 pa-0" grid-list-md fluid>
                    <v-layout row wrap class="ma-0 pa-0" v-if="item.attempts > 1 && item.attemptsCollection && item.type == 'salonhub'">
                      <h2 style="display: block; width: 100%;">Bekijk de informatie van alle intenties</h2>
                      <p style="width: 100%">Er zijn meerder intenties tot conversie gedaan door deze klant.</p>
                      <v-flex md4 xs6 v-for="(attempt, index) in item.attemptsCollection" :key="index" >
                        <div style="padding: 12px; margin: 0px; background-color: #fff" class="conversion-client-info">
                          <!-- <h3 style="font-weight: bold;">Afspraak gegevens</h3> -->
                          <div class="info-wrapper">
                            <h3 style="font-weight: bold;">{{ attempt.timestamp.seconds | moment("D MMMM YYYY - H:mm")}}u</h3>
                            

                            <div><span class="info-label">Naam:</span> <span class="info-data" v-if="attempt.clientData.name"> {{ attempt.clientData.name }}</span><span class="info-data" v-else> - </span></div>
                            <div><span class="info-label">Telefoon:</span> <span class="info-data"  v-if="attempt.clientData.phone">{{ attempt.clientData.phone }}</span><span class="info-data"  v-else> - </span></div>
                            <div><span class="info-label">Email:</span> <span class="info-data"  v-if="attempt.clientData.email">{{ attempt.clientData.email }}</span><span class="info-data" v-else> - </span></div>
                            <div v-if="(userRole == 'superadmin' && !demoMode) && attempt.clientData.ip && attempt.clientData.ip.query"><span class="info-label">IP-adres:</span> <span class="info-data"  v-if="attempt.clientData.ip && attempt.clientData.ip.query">{{ attempt.clientData.ip.query }}</span><span class="info-data" v-else> - </span></div>
                            <div style="width: 100%; height: 15px; float: left;"></div>
                            <div><span class="info-label">Vestiging:</span> <span class="info-data" v-if="attempt.salonhubData.branch">{{ attempt.salonhubData.branchName }}</span><span class="info-data"  v-else> - </span></div>
                            <div><span class="info-label">Datum:</span> <span class="info-data" v-if="attempt.salonhubData.steps && attempt.salonhubData.steps.date">{{ attempt.salonhubData.steps.date | moment("D MMMM YYYY") }}</span><span class="info-data"  v-else> - </span></div>
                            <div><span class="info-label">Tijd:</span> <span class="info-data" v-if="attempt.salonhubData.steps && attempt.salonhubData.steps.time">{{ attempt.salonhubData.steps.time }}</span><span class="info-data"  v-else> - </span></div>
                            <div><span class="info-label">Geslacht:</span> <span class="info-data" v-if="attempt.salonhubData.steps && attempt.salonhubData.steps.gender.name">{{ attempt.salonhubData.steps.gender.name }}</span><span class="info-data"  v-else> - </span></div>
                            <div><span class="info-label">Behandeling:</span> <span class="info-data" v-if="attempt.salonhubData.steps && attempt.salonhubData.steps.treatment.name">{{ attempt.salonhubData.steps.treatment.name }}</span><span class="info-data"  v-else> - </span></div>
                            <div><span class="info-label">Medewerker:</span> <span class="info-data" v-if="attempt.salonhubData.steps && attempt.salonhubData.steps.employee.name">{{ attempt.salonhubData.steps.employee.name }}</span><span class="info-data"  v-else> - </span></div>
                            <div v-if="attempt.startUrl"><span class="info-label">Start url:</span> <span class="info-data">{{ attempt.startUrl }}</span></div>
                            <div>
                              <div v-if="attempt.progress.callMe" style=" margin: 5px 0; padding: 5px; border-radius: 3px; background-color: #4caf50; display: inline-block">
                                <v-icon  color="menu" >mdi-card-account-phone</v-icon>                                             
                                <span class="px-2" style="color: #fff">Klant wil graag gebeld worden voor hulp.</span>
                              </div>
                            </div>

                            <div v-if="attempt.smsSend" style=" margin: 5px 0; padding: 5px; border-radius: 3px">
                              <v-icon  color="text" >mdi-cellphone-message</v-icon>                                             
                              <span class="px-2">Sms verzonden naar de klant.</span>
                            </div>
                            <div>
                              <div v-if="attempt.salonhubData && attempt.salonhubData.closeReason" style=" margin: 5px 0; padding: 5px; border-radius: 3px; display: inline-block" :style="{backgroundColor: $vuetify.theme.themes[theme].text}">
                                <v-icon  color="menu" >mdi-message-text</v-icon>
                                <span class="px-2" :style="{color: $vuetify.theme.themes[theme].menu}">
                                  <strong>Feedback: </strong>                                                                     
                                  <span :style="{color: $vuetify.theme.themes[theme].menu}" v-if="attempt.salonhubData.closeReason == 'noSpaceFound'">Ik kan geen geschikte tijd vinden.</span>
                                  <span :style="{color: $vuetify.theme.themes[theme].menu}" v-else-if="attempt.salonhubData.closeReason == 'restartingWidget'">Ik wil de widget opnieuw starten.</span>
                                  <span :style="{color: $vuetify.theme.themes[theme].menu}" v-else-if="attempt.salonhubData.closeReason == 'widgetError'">Widget werkt niet goed.</span>
                                  <span :style="{color: $vuetify.theme.themes[theme].menu}" v-else>{{ attempt.salonhubData.closeReason }}</span>
                                </span> 
                              </div>
                            </div>

                          </div>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
          
                </v-card-text>
              </v-card>
            </td>
            </template>
            
          </v-data-table>
          <div class="text-center pa-4" v-if="conversionsFiltered.length > 50">
            <v-pagination
              circle
              v-model="conversionSelectedPage"
              :length="conversionSelectorPages"
              :total-visible="9"
            ></v-pagination>
          </div>


        </div>

      </div>
    </v-card>

    <!-- / Delete Dialog \-->
    <v-dialog v-model="removeConversionsDialog" max-width="450">
      <v-card>
        <v-card-title class="pillar-card-title" >
          <h2><span style="color:#fff;" v-if="selected.length == 1">Conversie</span><span style="color:#fff;" v-else>Conversies</span> verwijderen</h2>
          <div class="pillar-card-title-close" @click="removeConversionsDialog = false"></div>
        </v-card-title>
        <v-card-text>
          <div class="pt-4">
          Weet u zeker dat u deze <span v-if="selected.length == 1">conversie</span><span v-else>conversies</span> definitief wilt verwijderen?
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="hogans-modal-footer clear">
            <v-btn class="modal-button-cancel" outlined depressed color="#8B93A6" @click="removeConversionsDialog = false">Annuleren</v-btn>
            <v-btn class="modal-button-next" dark rounded :color="companySecondaryColor" @click="removeConversions()">Verwijderen<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- \ Delete Dialog / -->

    <!-- / New Blacklist Dialog \-->
    <v-dialog v-model="newBlacklist.dialog" max-width="600">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 class="white--text">Telefoonnummer toevoegen aan Blacklist</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="newBlacklist.dialog = false">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-alert
          class="ma-0 pa-1"
          v-if="newBlacklist.feedback"
          :value="true"
          type="warning"
          >
        {{ newBlacklist.feedback }} 
        </v-alert>

        <v-divider></v-divider>
          
        <v-card-text>
          <v-text-field
            class="mt-4"
            outlined
            background-color="background"
            :color="companyPrimaryColor"
            label="Telefoonummer"
            v-model="newBlacklist.phone"
            required
            hide-details
          ></v-text-field>

          <v-textarea
            class="mt-4"
            outlined
            background-color="background"
            :color="companyPrimaryColor"
            label="Opmerkingen"
            row="6"
            v-model="newBlacklist.comment"
            required
            hide-details
          ></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="newBlacklist.dialog = false"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companySecondaryColor"
                  @click="addPhoneToBlacklist()"
                  >
                  Opslaan
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- \ New Blacklist Dialog / -->


  </div>
</template>


<script>

import { bus } from "../main";
import moment from "moment";
import db from "../firebase/init";
import platform from 'platform'; 
import lodash from 'lodash';
import axios from 'axios';
import slugify from "slugify";


export default {
  name: "WidgetStats",
  props: ["urlStart", "urlEnd"],

  data: () => ({
    twoWeeksAgoUnix: moment().subtract(104, 'weeks').format('X'),
    expanded: [],
    loading: true,
    feedback: null,
    liveUpdates: false,
    liveUpdatesTimer: null,
    filterToday: true,
    filterWeek: false,
    filterMonth: false,
    filterPeriod: false,
    selectedPeriodDay: "01",
    selectedPeriodYear: moment().year(),
    selectedPeriodMonth: Number(moment().format("M")),
    activeCompData: {},
    conversions: [],
    activeCompDataOriginal: {},
    deleteCounter: 0,
    deleting: false,
    averageConversionTime: 300,
    companies: [],
    branches: [],
    activeBranch: {
      id: 'all',
      branchName: 'Alle'
    },
    branchNames: {},
    activeComp: "", 
    compStartYear: null,
    compStartMonth: null, 
    dataLoading: false,
    toggle_exclusive: 1,
    today: null,
    selected: [],
    removeConversionsDialog: false,
    conversionPeriodType: 'day',
    conversionPeriodStart: null,
    conversionPeriodEnd: null,
    conversionPeriodStartFormatted: null,
    conversionPeriodEndFormatted: null,
    currentMonth: Number(moment().format("M")),
    selectedSources: [],
    filter: {
      selectedSources: [],
      active: false
    },
    collapsedClient: null,
    timer: null,
    futureAppointmentsTimer: null,
    checkForUpdates: null,
    conversionSelectedPage: 1,
    searchCompanies: "",
    closeConversionReason: null,
    closeConversionReasonOther: null,
    closeConversionReasonOtherWait: null,
    conversionTableLabels: [],
    appointmentDateDialog: false,
    conversionSalonhubfeedback: null,
    closeConversionSuccessfull: true,
    conversionSalonhubfeedback: null,
    conversionsClustered: [],
    conversionPages: 20,
    pricePerMessageSend: 0.1495,
    blacklisted: new Array(),
    tableOptions: {
      sortBy: "timestampUnix",
      itemsPerPage: 20,
      sortDesc: false
    },
    newBlacklist: {
      dialog: false,
      phone: null,
      comment: null
    },
    headers:[
        {
          text: "",
          align: "left",
          value: "clientData.language",
          width: "40px"
        },
        {
          text: "",
          align: "left",
          value: "clientData",
          width: "50px"
        },
        {
          text: "",
          align: "left",
          value: "clientData.attempts",
          width: "50px"
        },
        {
          text: "Datum",
          align: "left",
          value: "timestampUnix",
          width: "110px"
        },
        {
          text: "Naam",
          align: "left",
          value: "clientData.name"
        },
        {
          text: "Type",
          align: "left",
          value: "type",
          width: "100px"
        },
         {
          text: "Salon",
          align: "left",
          value: "type",
          width: "130px"
        },
        {
          text: "Bron",
          align: "left",
          value: "source"
        },
        {
          text: "Opbrengst",
          align: "left",
          value: "value.number",
          width: "100px"
        },
        {
          text: "Succes",
          align: "left",
          value: "progress.completed",
          width: "100px"
        },
        {
          text: "",
          align: "left",
          width: "100px",
          sortable: false
        },
        {
          text: "",
          align: "right",
          width: "30px",
          sortable: false
        },
        {
          text: "",
          value: "data-table-expand",
          align: "right",
          width: "80px",
          sortable: false
        }
      ],
    clientType: [
      {
        id: false,
        name: 'Ja'
      },
      {
        id: true,
        name: 'Nee'
      },
    ],
    genders: [
      'Dames',
      'Heren'
    ],
    snackbar: true,
    conversieUpdates: [
      {
        show: true,
        company: "hbc",
        unix:1595928637
      },
      {
        show: true,
        company: "hogans",
        unix:1595928637
      },
      {
        show: true,
        company: "hogans",
        unix:1595928637
      }
    ],
    types: [
      {
        id: 'salonhub',
        name: 'Salonhub',
        color: 'white',
        outlined: false
      },
      {
        id: 'wordpressForm',
        name: 'Wordpress Formulier',
        color: 'black',
        outlined: true
      },
      {
        id: 'chatbotLandbot',
        name: 'Chatbot',
        color: 'red',
        outlined: true
      }
    ],
    updateCounter: 0,
    conversionKey: 0,
    sources: [],
    sourcesOriginal: [
      {
        query: 'nosource',
        name: 'Organisch',
        bgColor: {
          hex: '#cecece'
        },
        textColor: {
          hex: '#333'
        }
      },
      {
        query: 'unknown',
        name: 'Onbekend',
        bgColor: {
          hex: '#ccc'
        },
        textColor: {
          hex: '#333'
        }
      },
      {
        query: 'mc',
        name: 'Mailchimp',
        bgColor: {
          hex: '#ffe01b'
        },
        textColor: {
          hex: '#333'
        }
      },
      {
        query: 'adw',
        name: 'Adwords',
        bgColor: {
          hex: '#1a73e8'
        },
        textColor: {
          hex: '#fff'
        }
      }
    ],
    conversionTableValuesTest: [
        200,
        675,
        410,
        390,
        310,
        460,
        250,
        240
      ],
    conversionTableLabelsTest: [
        '12am',
        '3am',
        '6am',
        '9am',
        '12pm',
        '3pm',
        '6pm',
        '9pm'
      ],
    timeChecker: null,
    interval: null,
    updatesRunning: true,
    companiesLiveChecking: null 
  }),

  created() {
    this.loadUserComp();
    this.now = moment().format("YYYY-MM-DD")
    //this.today = moment().unix()
    this.updateDate();
    
  },

  destroyed(){
    this.updatesRunning = false;
    this.checkForUpdates;
  },

  methods: {
    filterSources(){
      this.conversionSelectedPage = 1;
      this.filter.selectedSources = _.cloneDeep(this.selectedSources)
    },

    updateDate(){
      this.timeChecker= setInterval(countdown, 1);
      let vm = this;

      function countdown() {
        vm.today = moment().unix()
      }
    },

    loadUserComp() {
      this.companiesLiveChecking = null;
      if(this.activeCompData && this.activeCompData.id){
        this.destroyFirbaseListener()
      }
      
      this.loaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = {};
              company.name = doc.data().name;
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
        this.checkNewConversions();
      })
    },

    loadActiveCompData() {
      this.loading = true;
      this.sources = _.cloneDeep(this.sourcesOriginal)
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
            if(doc.data().conversion.start){
              this.compStartYear = moment.unix(doc.data().conversion.start.seconds).format("YYYY")
              this.compStartMonth = moment.unix(doc.data().conversion.start.seconds).format("M")
            } else {
              this.compStartYear = moment().year()
              this.compStartMonth = moment().month()
            }
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
          this.selectedLanguage = this.activeCompDataOriginal.languages[0];
          this.loadBranches();
          this.loadBlacklisted();
        })
        .then(()=>{
          this.conversionSelectedPage = 1;
          if(this.activeCompData.conversion.sources.length > 0){
            this.activeCompData.conversion.sources.forEach(sourceItem=>{
              this.sources.push(sourceItem)
            })
          }
        })
        .then(() => {
          this.selectAllSources()
          this.sources.forEach(source => {
            this.filter.selectedSources.push(source.query)
          })
          this.loading = false;
          this.dataLoading = true;

          if(this.urlStart && this.urlEnd){
            // Url params aanwezig
            let currentDay = moment().startOf('day').format("YYYY-MM-DD")
            let tomorrow = moment().add(1, 'day').startOf('day').format("YYYY-MM-DD")
            let startCurrentWeek = moment().weekday(0).format("YYYY-MM-DD")
            let endCurrentWeek = moment().weekday(7).add(1, 'day').format("YYYY-MM-DD")
            let startCurrentMonth = moment().startOf('month').format("YYYY-MM-DD")
            let endCurrentMonth = moment().endOf('month').add(1, 'day').format("YYYY-MM-DD")

            if(this.urlStart == currentDay && this.urlEnd == tomorrow){
              this.filterConversionToday();
              // this.checkForFutureAppointments()
            } else if(this.urlStart == startCurrentWeek && this.urlEnd == endCurrentWeek){
              this.filterConversionWeek()
            } else if(this.urlStart == startCurrentMonth && this.urlEnd == endCurrentMonth){
              this.filterConversionMonth()
            } else {
              this.filterToday = false;
              this.filterWeek = false;
              this.filterMonth = false;
              this.filterPeriod = false;
              this.loadCustomPeriodFilter(this.urlStart, this.urlEnd, 'url')
            }
          }
          else {
            this.filterConversionToday()
            // this.checkForFutureAppointments();
          }
        })
        .catch(error => {
          this.loading = false;
          console.error("Error getting document:", error);
        });
    },

    selectAllSources(){
      this.selectedSources = []
      this.sources.forEach(source => {
        this.selectedSources.push(source.query)
      })
    },

    loadBranches(){
      this.branchNames = {};
      this.branches = [
        {
          id: 'all',
          branchName: 'Alle'
        }
      ];
      db.collection("branches")
        .where('compId', '==', this.activeCompData.id)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let branch = doc.data();
            branch.id = doc.id;
            this.branchNames[branch.branchNameSalonhub] = branch.branchName;
            this.branches.push(branch);
          })
        })
    },

    resetSalonhubConversion(){
      this.closeConversionSuccessfull = true;
      this.conversionSalonhubfeedback = null;
      this.closeConversionReason = null;
      this.closeConversionReasonOther = null;
      this.closeConversionReasonOtherWait = null;
    },

    removeConversions() {
      this.removeConversionsDialog = false;
      this.deleting = true;
      new Promise((resolve) => {
        let clusterCounter = 0;
        this.selected.forEach(conversionCluster => {
          let conversionCounter = 0;
          new Promise((resolve, reject) => {
            if(conversionCluster.attemptsCollection && conversionCluster.attemptsCollection.length > 0){
              conversionCluster.attemptsCollection.forEach(conversion => {
                db.collection("conversion")
                  .doc(conversion.id)
                  .delete()
                  .then(() => {
                    conversionCounter++;
                    let conversieIndex = _.findIndex(this.conversions, { 'id': conversion.id});
                    this.conversions.splice(conversieIndex, 1);
                    if (conversionCounter == conversionCluster.attemptsCollection.length) {
                      resolve();
                    }
                  })
                  .catch(error => {
                    console.error("Error removing conversion: ", error);
                    conversionCounter++;
                    if (conversionCounter == conversionCluster.attemptsCollection.length) {
                      resolve();
                    }
                  });
              })
            }
            else{
              resolve();
            }
          })
          .then(()=>{
            db.collection("conversion")
              .doc(conversionCluster.id)
              .delete()
              .then(() => {
                clusterCounter++;
                this.deleteCounter++;
                let conversieIndex = _.findIndex(this.conversions, { 'id': conversionCluster.id});
                this.conversions.splice(conversieIndex, 1);

                let conversieClusteredIndex = _.findIndex(this.conversionsClustered, { 'id': conversionCluster.id});
                this.conversionsClustered.splice(conversieIndex, 1);

                if (clusterCounter == this.selected.length) {
                  resolve();
                }
              })
              .catch(error => {
                console.error("Error removing conversion: ", error);
                clusterCounter++;
                this.deleteCounter++;
                if (clusterCounter == this.selected.length) {
                  resolve();
                }
              });
          })
        });
      })
      .then(() => {
        this.conversionKey++
        this.selected = [];
        this.deleteCounter = 0;
        this.deleting = false;
      });
    },

    checkBusyStatus(onHold, reason, button){
      if(reason){
        if(onHold){   
          if(reason == 'tryAgain' || reason == 'notReachable'){
            this.closeConversionReason = reason;
          }
          else{
            this.closeConversionReason = 'otherReasonWait';
            this.closeConversionReasonOtherWait = reason;
          }
          this.closeConversionSuccessfull = 'wait';
        } else {
          this.closeConversionReason = null;
          this.closeConversionSuccessfull = true;
          this.closeConversionReasonOtherWait = null;
        }
      }  
    },

    updateConversionWait(item, index){
      this.conversionSalonhubfeedback = null
      if( (this.closeConversionReason == 'notReachable' || this.closeConversionReason == 'tryAgain') || (this.closeConversionReason == 'otherReasonWait' && this.closeConversionReasonOtherWait)){
    
        let noSuccessReason = this.closeConversionReason

        if(this.closeConversionReason == "otherReasonWait"){
          noSuccessReason = this.closeConversionReasonOtherWait
        }

        db.collection("conversion")
        .doc(item.id)
        .set({
          value: item.value ? item.value : new Object(),
          progress: {
            availableForAction: true,
            onHold: true,
            completed: false,
            completedBy: this.userFirstName + " " + this.userLastName,
            completedByCompId: this.userCompany,
            completedOn: new Date(),
            noSuccessReason: noSuccessReason
          } 
        }, { merge: true })
        .then(()=>{
          item.progress = {
            availableForAction: true,
            onHold: true,
            completed: false,
            completedBy: this.userFirstName + " " + this.userLastName + " (" + this.userCompany + ")",
            completedByCompId: this.userCompany,
            completedOn: {
              seconds: moment().unix()
            },
            noSuccessReason: noSuccessReason
          }
        }).then(()=>{
          let conversieIndex = _.findIndex(this.conversions, { 'id': item.id});
          this.conversions[conversieIndex] = item
        })
        .catch(error=>{
          console.error("Updaten van conversie niet gelukt: ", error)
        })
      } else {
        this.conversionSalonhubfeedback = "Vul alle velden in."
      }
    },

    addPhoneToBlacklist(){
      this.newBlacklist.phone = slugify(this.newBlacklist.phone, {
        replacement: "",
        remove: /[!@#$%^&*()"';:.,+-]/g,
        lower: true
      })
      
      db.collection("widgetBlacklist").add({
        phone: this.newBlacklist.phone,
        comment: this.newBlacklist.comment,
        compId: this.activeCompData.id,
        userId: `${this.userFirstName} ${this.userLastName}`, 
        created: new Date()
      })
      .then(()=>{
        this.blacklisted.push(this.newBlacklist)
        this.newBlacklist = {
          dialog: false,
          phone: null,
          comment: null
        };
        this.checkForBlacklist(this.collapsedClient);
      })
    },

    checkForBlacklist(item){
      let blacklisted = false;
      let blacklistData = {
        status: false,
        comment: ""
      };
        if(item.clientData.phone){
          let formattedPhone = slugify(item.clientData.phone, {
          replacement: "",
          remove: /[!@#$%^&*()"';:.,+-]/g,
          lower: true
        })
        let formattedPhoneShort =  formattedPhone.substr(formattedPhone.length - 8);
        console.log("formattedPhoneShort: ", formattedPhoneShort)
        new Promise((resolve)=>{
          let counter = 0;
          if(this.blacklisted.length > 0){
            this.blacklisted.forEach((blacklistItem)=>{
              if((blacklistItem.phone).includes(formattedPhoneShort)){
                blacklistData.status = true;
                blacklistData.comment = blacklistItem.comment ? blacklistItem.comment : null;
              }
              counter++
              if(counter == this.blacklisted.length){
                resolve()
              }
            })
          }
          else{
            resolve()
          }
        })
        .then(()=>{
          item.blacklisted = blacklistData
        })
      }
      

     
    },


    loadBlacklisted(){
      this.blacklisted = new Array()
      db.collection("widgetBlacklist")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let item = doc.data();
            item.id = doc.id;
            this.blacklisted.push(item);
          });
        })
        .catch(error=>{
          console.error("Error loading widgetBlacklist: ", error)
        })
    },

    updateConversionNoSuccess(item, index){
      this.conversionSalonhubfeedback = null
      let callMeValue = false;
       

      if( (this.closeConversionReason == 'otherwiseSuccesfull' || this.closeConversionReason == 'noDeal') || (this.closeConversionReason == 'otherReason' && this.closeConversionReasonOther)){
    
        let noSuccessReason = this.closeConversionReason

        if(this.closeConversionReason == "otherReason"){
          noSuccessReason = this.closeConversionReasonOther
        }
        if(item.progress.callMe){
          callMeValue = item.progress.callMe
        }

        db.collection("conversion")
        .doc(item.id)
        .set({
          value: item.value ? item.value : new Object(),
          progress: {
            availableForAction: false,
            completed: false,
            onHold: false,
            callMe: callMeValue,
            completedBy: this.userFirstName + " " + this.userLastName,
            completedByCompId: this.userCompany,
            completedOn: new Date(),
            noSuccessReason: noSuccessReason
          } 
        }, { merge: true })
        .then(()=>{
          item.progress = {
            availableForAction: false,
            completed: false,
            onHold: false,
            callMe: callMeValue,
            completedBy: this.userFirstName + " " + this.userLastName + " (" + this.userCompany + ")",
            completedByCompId: this.userCompany,
            completedOn: {
              seconds: moment().unix()
            },
            noSuccessReason: noSuccessReason
          }
        }).then(()=>{
          let conversieIndex = _.findIndex(this.conversions, { 'id': item.id});
          this.conversions[conversieIndex] = item
        })
        .catch(error=>{
          console.error("Updaten van conversie niet gelukt: ", error)
        })
      } else {
        this.conversionSalonhubfeedback = "Vul alle velden in."
      }
    },

    updateConversionChatbotSuccess(item, index){
      db.collection("conversion")
        .doc(item.id)
        .set({
          progress: {
            availableForAction: false,
            completed: true,
            onHold: false,
            completedBy: this.userFirstName + " " + this.userLastName,
            completedByCompId: this.userCompany,
            completedOn: new Date()
          } 
        }, { merge: true })
        .then(()=>{
          item.progress = {
            availableForAction: false,
            completed: true,
            onHold: false,
            completedBy: this.userFirstName + " " + this.userLastName,
            completedByCompId: this.userCompany,
            completedOn: {
              seconds: moment().unix()
            }
          }
        })
        .then(()=>{
          let conversieIndex = _.findIndex(this.conversions, { 'id': item.id});
          this.conversions[conversieIndex] = item
        })
        .catch(error=>{
          console.error("Updaten van conversie niet gelukt: ", error)
        })
    },

    updateConversionSuccess(item, index){
      this.conversionSalonhubfeedback = null;
      let callMeValue = false;
      if(item.progress.callMe){
          callMeValue = item.progress.callMe
        }

      if(item.salonhubData.branch && item.salonhubData.steps.date && item.salonhubData.steps.time && item.salonhubData.steps.treatment.name && item.salonhubData.steps.gender.name && item.salonhubData.steps.employee.name && item.value.number){
        let changedSalonhubData = _.cloneDeep(item.salonhubData)
        let chosenDate = _.cloneDeep(changedSalonhubData.steps.date)
        changedSalonhubData.steps.date = moment(chosenDate).format("DD-MM-YYYY")
        changedSalonhubData.steps.datestamp = moment(chosenDate).unix()

        db.collection("conversion")
        .doc(item.id)
        .set({
          salonhubData: changedSalonhubData,
          value: item.value,
          progress: {
            availableForAction: false,
            completed: true,
            onHold: false,
            callMe: callMeValue,
            completedBy: this.userFirstName + " " + this.userLastName,
            completedByCompId: this.userCompany,
            completedOn: new Date()
          } 
        }, { merge: true })
        .then(()=>{
          item.salonhubData.steps.date = moment(chosenDate).format("DD-MM-YYYY")
          item.salonhubData.steps.datestamp = moment(chosenDate).unix()
          item.progress = {
            availableForAction: false,
            completed: true,
            onHold: false,
            callMe: callMeValue,
            completedBy: this.userFirstName + " " + this.userLastName,
            completedByCompId: this.userCompany,
            completedOn: {
              seconds: moment().unix()
            }
          }
        }).then(()=>{
          let conversieIndex = _.findIndex(this.conversions, { 'id': item.id});
          this.conversions[conversieIndex] = item
        })
        .catch(error=>{
          console.error("Updaten van conversie niet gelukt: ", error)
        })
      } else {
        this.conversionSalonhubfeedback = "Vul alle velden in."
      }
      
    },

    checkForFutureAppointments(){
      let today = moment().format("YYYY-MM-DD")
      console.log("checkForFutureAppointments: ", `https://salonhubwidget.hogans.nl/validateAppointment?companyId=${this.activeComp}&futureWeeks=8&start=${today}T04:00:00&end=${today}T23:59:00`)
      axios.get(`https://salonhubwidget.hogans.nl/validateAppointment?companyId=${this.activeComp}&futureWeeks=8&start=${today}T04:00:00&end=${today}T23:59:00`)
        .then(response => {
          console.log("checkForFutureAppointments response: ", response.data)
        })
        .catch(error=>{ 
          console.error("Error getting checkForFutureAppointments", error)
        })
    },

    toggle () {
      this.$nextTick(() => {
        if(this.chooseAllSources) {
          this.selectedSources = []
        } else {
          this.selectAllSources()
        }
      })
    },

    filterConversionToday(){
      this.filterToday = true;
      this.filterWeek = false;
      this.filterMonth = false;
      this.filterPeriod = false;
      let firstDate = moment().startOf('day').format("YYYY-MM-DD")
      let lastDate = moment().endOf('day').add(1, 'day').format("YYYY-MM-DD")
      this.loadConversionDate(firstDate, lastDate, 'day')
    },

    filterConversionWeek(){
      this.filterToday = false;
      this.filterWeek = true;
      this.filterMonth = false;
      this.filterPeriod = false;
      let firstDate = moment().weekday(0).subtract(2, 'days').format("YYYY-MM-DD")
      let lastDate = moment().weekday(7).format("YYYY-MM-DD")
  
      this.loadConversionDate(firstDate, lastDate, 'week')
    },

    filterConversionMonth(){
      this.filterToday = false;
      this.filterWeek = false;
      this.filterMonth = true;
      this.filterPeriod = false;
      let firstDate = moment().startOf('month').format("YYYY-MM-DD")
      let lastDate = moment().endOf('month').add(1, 'days').format("YYYY-MM-DD")

      this.loadConversionDate(firstDate, lastDate, 'month')
    },

    filterConversionPeriod(){
      this.filterToday = false;
      this.filterWeek = false;
      this.filterMonth = false;
      this.filterPeriod = true;
    },

    loadCustomPeriodFilter(start, end, filter){
      if(filter == 'url'){
        this.loadConversionDate(start, end, 'month')
      } else {
        this.selectedPeriodDay = '01'
        let selectedDate = this.selectedPeriodYear+"-"+this.selectedPeriodMonth+"-01"
        let firstDate = moment(selectedDate).startOf('month').format("YYYY-MM-DD")
        let lastDate = moment(selectedDate).endOf('month').add(1, 'days').format("YYYY-MM-DD")

        this.loadConversionDate(firstDate, lastDate, 'month')
      }
    },

    loadConversionDate(firstDate, lastDate, type){

        // this.destroyFirbaseListener()

      this.dataLoading = true;
      this.conversions = []
      let start = new Date(firstDate) // firstDate heeft format YYYY-MM-DD
      let end = new Date(lastDate) // lastDate heeft format YYYY-MM-DD
      this.conversionSelectedPage = 1;

      this.conversionPeriodType =  type,

      this.conversionPeriodStart = moment(firstDate).subtract(1, 'days').format("D MMMM YYYY")
      this.conversionPeriodEnd = moment(lastDate).subtract(1, 'days').format("D MMMM YYYY")
      this.conversionPeriodStartFormatted = moment(firstDate).format("D MMMM YYYY")
      this.conversionPeriodEndFormatted = moment(lastDate).subtract(1, 'days').format("D MMMM YYYY")

      if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?start=' + firstDate+ '&end=' + lastDate;
        window.history.pushState({path:newurl},'',newurl);
      }

      let numberOfDays = moment(lastDate).diff(firstDate, 'days', false) + 1;
      this.conversionTableLabels = Array.apply(null, Array(numberOfDays))
      let counter = 0

      this.conversionTableLabels.forEach((year, index)=>{
        this.conversionTableLabels[index] = moment(firstDate).add(counter, 'days').format("D MMM")
        counter++
      })

      // this.$router.push({ path: "widget-statistieken", query: {start: firstDate, end: lastDate}, silent: true })  
      db.collection("conversion")
        .where("companyId", "==", this.activeCompData.id)
        .where("timestamp", ">=", start)
        .where("timestamp", "<=", end)
        .orderBy("timestamp")
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let conversion = doc.data()
            conversion.id = doc.id
            conversion.blacklisted = {status: false, comment: ""};
            let source = _.find(this.sources, { 'query': conversion.source});

            conversion.clientData.email = String(doc.data().clientData.email).toLowerCase() 

            conversion.timestampConverted = moment.unix(doc.data().timestamp.seconds).format("YYYY-MM-DD")
            conversion.timestampUnix = doc.data().timestamp.seconds

            if(source){
              conversion.source = source.query
            }
            
            else if(doc.data().source && doc.data().source != "notInstalled" && !source){
              conversion.source = 'unknown'
              conversion.originalSource = doc.data().source
            } 
            else {
              conversion.source = 'nosource'
            }

            if(!doc.data().timestampUpdated){
              conversion.timestampUpdated = doc.data().timestamp
            }
          
            if(doc.data().type == 'salonhub' && doc.data().progress.completed == false){
              if(!conversion.salonhubData.steps){
                let chosenDate = null
                let chosenDateStamp = null
                let chosenTime = null
                let chosenEmployee = {
                    name: null,
                    id: null
                  } 
                let chosenGender = {
                    name: null,
                    id: null
                  }
                let chosenTreatment = {
                    name: null,
                    id: null
                  }
                if(doc.data().salonhubData.steps && doc.data().salonhubData.steps.date){
                  chosenDate.date = doc.data().salonhubData.steps.date;
                  chosenDateStamp = doc.data().salonhubData.steps.datestamp;
                }
                if(doc.data().salonhubData.steps && doc.data().salonhubData.steps.time){
                  chosenTime = doc.data().salonhubData.steps.time
                }
                if(doc.data().salonhubData.steps && doc.data().salonhubData.steps.employee){
                  chosenEmployee = doc.data().salonhubData.steps.employee
                }
                if(doc.data().salonhubData.steps && doc.data().salonhubData.steps.gender){
                  chosenGender = doc.data().salonhubData.steps.gender
                }
                if(doc.data().salonhubData.steps && doc.data().salonhubData.steps.treatment){
                  chosenTreatment = doc.data().salonhubData.steps.treatment
                }
                conversion.salonhubData.steps = {
                  date: chosenDate,
                  datestamp: chosenDateStamp,
                  time: chosenTime,
                  employee: chosenEmployee,
                  gender: chosenGender,
                  treatment: chosenTreatment
                }
              } 
              else{
                if(doc.data().salonhubData.steps && doc.data().salonhubData.steps.date){
                  conversion.salonhubData.steps.date = doc.data().salonhubData.steps.date;
                  conversion.salonhubData.steps.datestamp = doc.data().salonhubData.steps.datestamp;
                }
                else{
                  conversion.salonhubData.steps.date = null
                }
                if(!conversion.salonhubData.steps.time){
                  conversion.salonhubData.steps.time = null
                }
                if(!conversion.salonhubData.steps.employee){
                  conversion.salonhubData.steps.employee = {
                    name: null,
                    id: null
                  }
                }
                if(!conversion.salonhubData.steps.gender){
                  conversion.salonhubData.steps.gender = {
                    name: null,
                    id: null
                  }
                }
                if(!conversion.salonhubData.steps.treatment){
                  conversion.salonhubData.steps.treatment = {
                    name: null,
                    id: null
                  }
                }
              }
              if(!conversion.value){
                conversion.value = {
                  number: null,
                  type: 'amount'
                }
              }
            }
            this.conversions.push(conversion)
          })
        })
        
        .then(()=>{
          this.filterUniqueConversions()
          this.dataLoading = false;
          // this.checkForNewConversions()
        })
        .catch(error=>{
          this.dataLoading = false;
          console.error("Laden van conversies is niet gelukt: ", error)
        })
    },

    checkForNewConversions(){
      this.conversions = [];
      let start = new Date(moment(this.conversionPeriodStart, "D MMM YYYY").add(1, 'days').format("YYYY/MM/DD"))
      let end = new Date(moment(this.conversionPeriodEnd, "D MMM YYYY").add(1, 'days').format("YYYY/MM/DD"))

      this.checkForUpdates =  db.collection("conversion")
        .where("companyId", "==", this.activeCompData.id)
        .where("timestamp", ">=", start)
        .where("timestamp", "<=", end)
        .orderBy("timestamp")
        .onSnapshot(querySnapshot=> {
          
          this.today = moment().unix()
          querySnapshot.docChanges().forEach((change) => {
            let conversion = change.doc.data();
            conversion.id = change.doc.id;
            conversion.blacklisted = {status: false, comment: ""};
            conversion.clientData.email = String(change.doc.data().clientData.email).toLowerCase() 

            let source = _.find(this.sources, { 'query': conversion.source});

            conversion.timestampUnix = change.doc.data().timestamp.seconds
            conversion.timestampConverted = moment.unix(conversion.timestampUnix).format("YYYY-MM-DD")
            
            if(source){
              conversion.source = source.query
            }
              
            else if(change.doc.data().source && change.doc.data().source != "notInstalled" && !source){
              conversion.source = 'unknown'
              conversion.originalSource = change.doc.data().source
            } 
            else {
              conversion.source = 'nosource'
            }

            if(!change.doc.data().timestampUpdated){
              conversion.timestampUpdated = change.doc.data().timestamp
            }

            if(change.doc.data().type == 'salonhub' && change.doc.data().progress.completed == false){
              if(!conversion.salonhubData.steps){
                let chosenDate = null
                let chosenDateStamp = null
                let chosenTime = null
                let chosenEmployee = {
                    name: null,
                    id: null
                  } 
                let chosenGender = {
                    name: null,
                    id: null
                  }
                let chosenTreatment = {
                    name: null,
                    id: null
                  }
                if(change.doc.data().salonhubData.steps && change.doc.data().salonhubData.steps.date){
                  chosenDate.date = change.doc.data().salonhubData.steps.date
                  chosenDateStamp = change.doc.data().salonhubData.steps.datestamp
                }
                if(change.doc.data().salonhubData.steps && change.doc.data().salonhubData.steps.time){
                  chosenTime = change.doc.data().salonhubData.steps.time
                }
                if(change.doc.data().salonhubData.steps && change.doc.data().salonhubData.steps.employee){
                  chosenEmployee = change.doc.data().salonhubData.steps.employee
                }
                if(change.doc.data().salonhubData.steps && change.doc.data().salonhubData.steps.gender){
                  chosenGender = change.doc.data().salonhubData.steps.gender
                }
                if(change.doc.data().salonhubData.steps && change.doc.data().salonhubData.steps.treatment){
                  chosenTreatment = change.doc.data().salonhubData.steps.treatment
                }
                conversion.salonhubData.steps = {
                  date: chosenDate,
                  datestamp: chosenDateStamp,
                  time: chosenTime,
                  employee: chosenEmployee,
                  gender: chosenGender,
                  treatment: chosenTreatment
                }
              } 
              else{

                if(change.doc.data().salonhubData.steps && change.doc.data().salonhubData.steps.date){
                  conversion.salonhubData.steps.date = change.doc.data().salonhubData.steps.date
                  conversion.salonhubData.steps.datestamp = change.doc.data().salonhubData.steps.datestamp
                }
                else{
                  conversion.salonhubData.steps.date = null
                }
                if(!conversion.salonhubData.steps.time){
                  conversion.salonhubData.steps.time = null
                }
                if(!conversion.salonhubData.steps.employee){
                  conversion.salonhubData.steps.employee = {
                    name: null,
                    id: null
                  }
                }
                if(!conversion.salonhubData.steps.gender){
                  conversion.salonhubData.steps.gender = {
                    name: null,
                    id: null
                  }
                }
                if(!conversion.salonhubData.steps.treatment){
                  conversion.salonhubData.steps.treatment = {
                    name: null,
                    id: null
                  }
                }
              }
              if(!conversion.value){
                conversion.value = {
                  number: null,
                  type: 'amount'
                }
              }
            }

            if (change.type === "added") {
                console.log("Nieuwe Conversie")
                this.conversions.push(conversion)
            }
            if (change.type === "modified") {
                // console.log("Aangepaste Conversie: ", conversion)
                let index = _.findIndex(this.conversions, { 'id': conversion.id });
                // console.log("index gevonden: ", index)
                this.conversions[index] = conversion;
            }
            if (change.type === "removed") {
                // console.log("Conversie verwijderd: ", conversion)
                let index = _.findIndex(this.conversions, { 'id': conversion.id });
                // console.log("index gevonden: ", index)
                this.conversions[index].splice(index, 1);
            }

            // this.conversions.push(conversion)
            
          }, function(error) {
            console.error("Laden van conversies is niet gelukt: ", error)
            this.checkForUpdates

          });
          
          this.filterUniqueConversions()
        })

        this.liveUpdates = true;
        let seconds = 10800
        
        this.timer = setInterval(()=> {
          seconds = seconds - 1
          let hours = Number(Math.floor(seconds / 60 / 60));
          let minutes = Number(Math.floor((seconds - (hours * 60 * 60)) / 60))
          let hoursFormatted = hours.length  < 10 ? '0' + hours: hours;
          let minutesFormatted = minutes < 10 ? '0' + minutes: minutes;
          let remainingSeconds =  ("0" + (seconds - (minutes * 60))).slice(-2);
          this.liveUpdatesTimer =  hoursFormatted + ":" + minutesFormatted + ":" + remainingSeconds
        }, 1000)

        // this.futureAppointmentsTimer = setInterval(()=> {
        //   this.checkForFutureAppointments();
        // }, 900000)

        setTimeout(()=>{ 
          stopLiveUpdates();
        }, 10800000); 
    },


    // Oude functie
    // checkForNewConversions(){
    //   let start = new Date(moment(this.conversionPeriodStart, "D MMM YYYY").add(1, 'days').format("YYYY/MM/DD"))
    //   let end = new Date(moment(this.conversionPeriodEnd, "D MMM YYYY").add(1, 'days').format("YYYY/MM/DD"))

    //   this.checkForUpdates =  db.collection("conversion")
    //     .where("companyId", "==", this.activeCompData.id)
    //     .where("timestamp", ">=", start)
    //     .where("timestamp", "<=", end)
    //     .orderBy("timestamp")
    //     .onSnapshot(querySnapshot=> {
    //       this.conversions = []
    //       this.today = moment().unix()
    //       querySnapshot.forEach(doc=> {
    //         let conversion = doc.data()
    //         conversion.id = doc.id
    //         conversion.clientData.email = String(doc.data().clientData.email).toLowerCase() 

    //         let source = _.find(this.sources, { 'query': conversion.source});

    //         conversion.timestampUnix = doc.data().timestamp.seconds
    //         conversion.timestampConverted = moment.unix(conversion.timestampUnix).format("YYYY-MM-DD")
            
    //         if(source){
    //           conversion.source = source.query
    //         }
              
    //         else if(doc.data().source && doc.data().source != "notInstalled" && !source){
    //           conversion.source = 'unknown'
    //           conversion.originalSource = doc.data().source
    //         } 
    //         else {
    //           conversion.source = 'nosource'
    //         }

    //         if(!doc.data().timestampUpdated){
    //           conversion.timestampUpdated = doc.data().timestamp
    //         }

    //         if(doc.data().type == 'salonhub' && doc.data().progress.completed == false){
    //           if(!conversion.salonhubData.steps){
    //             let chosenDate = null
    //             let chosenDateStamp = null
    //             let chosenTime = null
    //             let chosenEmployee = {
    //                 name: null,
    //                 id: null
    //               } 
    //             let chosenGender = {
    //                 name: null,
    //                 id: null
    //               }
    //             let chosenTreatment = {
    //                 name: null,
    //                 id: null
    //               }
    //             if(doc.data().salonhubData.steps && doc.data().salonhubData.steps.date){
    //               chosenDate.date = doc.data().salonhubData.steps.date
    //               chosenDateStamp = doc.data().salonhubData.steps.datestamp
    //             }
    //             if(doc.data().salonhubData.steps && doc.data().salonhubData.steps.time){
    //               chosenTime = doc.data().salonhubData.steps.time
    //             }
    //             if(doc.data().salonhubData.steps && doc.data().salonhubData.steps.employee){
    //               chosenEmployee = doc.data().salonhubData.steps.employee
    //             }
    //             if(doc.data().salonhubData.steps && doc.data().salonhubData.steps.gender){
    //               chosenGender = doc.data().salonhubData.steps.gender
    //             }
    //             if(doc.data().salonhubData.steps && doc.data().salonhubData.steps.treatment){
    //               chosenTreatment = doc.data().salonhubData.steps.treatment
    //             }
    //             conversion.salonhubData.steps = {
    //               date: chosenDate,
    //               datestamp: chosenDateStamp,
    //               time: chosenTime,
    //               employee: chosenEmployee,
    //               gender: chosenGender,
    //               treatment: chosenTreatment
    //             }
    //           } 
    //           else{

    //             if(doc.data().salonhubData.steps && doc.data().salonhubData.steps.date){
    //               conversion.salonhubData.steps.date = doc.data().salonhubData.steps.date
    //               conversion.salonhubData.steps.datestamp = doc.data().salonhubData.steps.datestamp
    //             }
    //             else{
    //               conversion.salonhubData.steps.date = null
    //             }
    //             if(!conversion.salonhubData.steps.time){
    //               conversion.salonhubData.steps.time = null
    //             }
    //             if(!conversion.salonhubData.steps.employee){
    //               conversion.salonhubData.steps.employee = {
    //                 name: null,
    //                 id: null
    //               }
    //             }
    //             if(!conversion.salonhubData.steps.gender){
    //               conversion.salonhubData.steps.gender = {
    //                 name: null,
    //                 id: null
    //               }
    //             }
    //             if(!conversion.salonhubData.steps.treatment){
    //               conversion.salonhubData.steps.treatment = {
    //                 name: null,
    //                 id: null
    //               }
    //             }
    //           }
    //           if(!conversion.value){
    //             conversion.value = {
    //               number: null,
    //               type: 'amount'
    //             }
    //           }
    //         }

    //         this.conversions.push(conversion)
            
    //       }, function(error) {
    //         console.error("Laden van conversies is niet gelukt: ", error)
    //         this.checkForUpdates

    //       });
          
    //       this.filterUniqueConversions()
    //     })

    //     this.liveUpdates = true;
    //     let seconds = 10800
        
    //     this.timer = setInterval(()=> {
    //       seconds = seconds - 1
    //       let hours = Number(Math.floor(seconds / 60 / 60));
    //       let minutes = Number(Math.floor((seconds - (hours * 60 * 60)) / 60))
    //       let hoursFormatted = hours.length  < 10 ? '0' + hours: hours;
    //       let minutesFormatted = minutes < 10 ? '0' + minutes: minutes;
    //       let remainingSeconds =  ("0" + (seconds - (minutes * 60))).slice(-2);
    //       this.liveUpdatesTimer =  hoursFormatted + ":" + minutesFormatted + ":" + remainingSeconds
    //     }, 1000)

    //     setTimeout(()=>{ 
    //       stopLiveUpdates();
    //     }, 10800000); 
    // },

    stopLiveUpdates(){
      this.liveUpdates = false;
      clearInterval(this.timer)
      clearInterval(this.futureAppointmentsTimer)
      this.liveUpdatesTimer =  null;
      this.checkForUpdates
      // console.log("Live checken voorbij")
    },

    filterUniqueConversions(){
      // CLUSTERING MULTIPLE ATTEMPTS of 1 PERSON

      // Filter on
      // -EMAIL: Only conversion attempts with the same EMAIL are clustered
      // -IP: Only conversion attempts with the same IP are clustered
      // -DATE OF TODAY: Only conversion attempts on the same DAY are clustered
      // -COMPLETED: Only 1 completed can be in cluster

      this.conversionsClustered = []

      let uniqConversions = _.uniqBy(this.conversions, conversionItem => [conversionItem.clientData.email, conversionItem.clientData.ip.query, conversionItem.timestampConverted].join());

      // Get unique conversion items
      uniqConversions.forEach(conversion =>{
        let conversionItems = _.filter(this.conversions, function(conversionItem){
          return conversionItem.clientData.email == conversion.clientData.email && conversionItem.clientData.ip.query == conversion.clientData.ip.query && conversionItem.timestampConverted == conversion.timestampConverted;
        });
        let callMe = false;
        let smsSend = false;
        let closeReason = false;

        // console.log("conversionItems: ", conversionItems)
        if(conversionItems.length == 1){
          // console.log("Item heeft 1 conversie attempt")
          conversion.attempts = 1
          this.conversionsClustered.push(conversion)
        } 
        else {
          // console.log("Item heeft meerder conversie attempt")
          let conversionAttempts = conversionItems.length

          // Check for multiple completed Items
          let completedConversionItems = _.filter(conversionItems, function(completedItem){
            return completedItem.progress.completed ;
          });

          if(completedConversionItems.length > 1){
            // More completedItems
            let multipleConversionOrderedByDate = _.orderBy(conversionItems, ['timestampUnix'], ['desc']);
            let splitsedItemsCollection = []
            let counter = 0
            let completedItemCluster = null
            let emptyArray = [];
            


            new Promise((resolve, reject)=>{
              multipleConversionOrderedByDate.forEach(item =>{
                counter++
                if(item.progress.callMe){
                  callMe = true;
                } 
                if(item.smsSend){
                  smsSend = true;
                }
                 if(item.salonhubData.closeReason){
                  closeReason = true;
                }  

                if(item.progress.completed){
                  splitsedItemsCollection.push([])
                  if(completedItemCluster == null){
                    completedItemCluster = 0;
                  } else {
                    completedItemCluster++
                  }
                  splitsedItemsCollection[completedItemCluster].push(item)
                } 
                else {
                  if(counter == 1){
                    item.attempts = 1
                    this.conversionsClustered.push(item)
                  }
                  else {
                    // console.log("completedItemCluster: ", completedItemCluster, item)
                    splitsedItemsCollection[completedItemCluster].push(item)
                  }
                }
                
                if(counter == multipleConversionOrderedByDate.length){
                  resolve()
                }
              })
            })
            .then(()=>{
              splitsedItemsCollection.forEach(splitsedItems => {
                // One or no completedItem
            
                let primaryConversion = {}
                let completedItem = _.find(splitsedItems, function(item) { return item.progress.completed });
                

                let conversionSources = []
                conversionSources = _.filter(splitsedItems, function(item){ return item.source != "nosource"}); // Get one of the used Sources if available
                
                if(completedItem){
                  // Find completed Item and set as default shown.

                  primaryConversion = completedItem
                  primaryConversion.clusterSmsSend = smsSend;
                  primaryConversion.clusterCallMe = callMe;
                  primaryConversion.clusterCloseReason = closeReason;

                  // Collect other attempts and set in item
                  primaryConversion.attemptsCollection = []
                  splitsedItems.forEach(attemptItem=>{
                    if(attemptItem.id != primaryConversion.id){
                      primaryConversion.attemptsCollection.push(attemptItem)
                    }
                  })

                  primaryConversion.attempts = splitsedItems.length
                  if(conversionSources.length > 0){
                    primaryConversion.source = conversionSources[0].source
                  }

                  this.conversionsClustered.push(primaryConversion)
                } 
                
                else{
                  // When no completed Item id found set most resent itme as default shown.
                  let conversionOrderedByDate = _.orderBy(conversionItems, ['timestampUnix'], ['desc']);

                  primaryConversion = conversionOrderedByDate[0]
                   primaryConversion.clusterSmsSend = smsSend;
                  primaryConversion.clusterCallMe = callMe;
                  primaryConversion.clusterCloseReason = closeReason;

                  primaryConversion.attempts = conversionItems.length
                  if(conversionSources.length > 0){
                    primaryConversion.source = conversionSources[0].source
                  }
                  this.conversionsClustered.push(primaryConversion)
                }
                
              })
            })
            

          }
          else{
            // One or no completedItem
            
            let primaryConversion = {}
            let completedItem = _.find(conversionItems, function(item) { return item.progress.completed });
            let conversionSources = []
            conversionSources = _.filter(conversionItems, function(item){ return item.source != "nosource"}); // Get one of the used Sources if available
            
            if(completedItem){
              // Find completed Item and set as default shown.

              primaryConversion = completedItem

              // Collect other attempts and set in item
              primaryConversion.attemptsCollection = []
              conversionItems.forEach(attemptItem=>{
                if(attemptItem.progress.callMe){
                  callMe = true;
                } 
                if(attemptItem.smsSend){
                  smsSend = true;
                }
                if(attemptItem.salonhubData.closeReason){
                  closeReason = true;
                }  
                if(attemptItem.id != primaryConversion.id){
                  primaryConversion.attemptsCollection.push(attemptItem)
                }
              })

              primaryConversion.attempts = conversionItems.length
              primaryConversion.clusterSmsSend = smsSend;
              primaryConversion.clusterCallMe = callMe;
              primaryConversion.clusterCloseReason = closeReason;
              if(conversionSources.length > 0){
                primaryConversion.source = conversionSources[0].source
              }

              this.conversionsClustered.push(primaryConversion)
            } 
            
            else{
              // console.log("Nog complete items")
              // When no completed Item id found set most resent itme as default shown.
              let conversionOrderedByDate = _.orderBy(conversionItems, ['timestampUnix'], ['desc']);

              primaryConversion = conversionOrderedByDate[0]

              // Collect other attempts and set in item
              primaryConversion.attemptsCollection = []
              conversionOrderedByDate.forEach(attemptItem=>{
                if(attemptItem.progress.callMe){
                  callMe = true;
                } 
                if(attemptItem.smsSend){
                  smsSend = true;
                } 
                if(attemptItem.salonhubData.closeReason){
                  closeReason = true;
                  // console.log("CloseReasong gevonden")
                } 
                if(attemptItem.id != primaryConversion.id){
                  primaryConversion.attemptsCollection.push(attemptItem)
                }
              })

              primaryConversion.attempts = conversionItems.length
              primaryConversion.clusterSmsSend = smsSend;
              primaryConversion.clusterCallMe = callMe;
              primaryConversion.clusterCloseReason = closeReason;
              if(conversionSources.length > 0){
                primaryConversion.source = conversionSources[0].source
              }
              this.conversionsClustered.push(primaryConversion)
            }
            
          }
        }
      })
    },
    
    counter(){
      if(this.updatesRunning) {
        this.updateCounter = parseInt(this.updateCounter) + 1;
      }
      else {
        clearInterval(this.interval);
        this.companiesLiveChecking = null;
      }
    },

    checkNewConversions(){
      let today = new Date()
      let start = today.setMinutes( today.getMinutes() - 2 );

      this.companiesLiveChecking;

      if(this.userRole == "superadmin" || this.userOperator){

        this.interval = setInterval(this.counter, 1000);

        this.companiesLiveChecking = db.collection("conversion")
          .where("timestamp", ">=", today)
          .onSnapshot(querySnapshot=> {
            querySnapshot.docChanges().forEach(change=> {
              if (change.type === "added") {
                // Snackbar weergeven voor elke nieuwe conversie
                this.userCompanies.forEach(company=>{
                  if(company == change.doc.data().companyId){
                    // console.log("CONVERSIE: ", company, change.doc.data())
                    let snackbarItem = {
                    unix: Number(moment().format('X')),
                    company: company,
                    show: true
                  }
                  this.conversieUpdates.push(snackbarItem)
                  }
                })
              }
            })
          })
      }
    }

  },

  computed: {

    updateCompany(){
      return id => _.find(this.companies, ['id', id]);
    },

    conversieUpdatesFiltered(){
      let index = this.updateCounter; 
      let unixNow = Number(moment().format('X'));
      let timeout = 25;
      let updates = [];
      this.conversieUpdates.forEach(update=>{
        if((update.unix > (unixNow - timeout)) && update.show == true){
          updates.push(update);
        }
      })
      return updates;
    },

    conversionSelectorPages(){
      return Math.ceil(this.conversionsFiltered.length / 50)
    },

    conversionPackage(){
      let packageStatus = { 
        type: 'inactive',
        days: 0
      }

      if(this.activeCompData.packages && this.activeCompData.packages.length > 0 && _.indexOf(this.activeCompData.packages, 'conversion') >= 0){
        packageStatus.type = 'active';
      }
      else{
        // Package not purchased, check for active trial
        if(this.activeCompData.trials && this.activeCompData.trials.length > 0){
          this.activeCompData.trials.forEach(trailPackage =>{
            if(trailPackage.id == 'conversion'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                packageStatus.type = 'trial';
                packageStatus.days = moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days').diff(moment(), 'days')
              }
            }
          })
        }
      }
      return packageStatus
    },

    liveUpdatesActive(){
      if(this.liveUpdates){
        return true
      }
      else {
        return false
      }
    },

    conversionTableValues(){
      let data = Array.apply(null, Array(this.conversionTableLabels.length))

      this.conversionTableLabels.forEach((day, index) =>{
        data[index] = 0
        let dayDate = moment(this.conversionPeriodStart).add(index, 'days').format('YYYY-MM-DD')
          this.conversionsFiltered.forEach(conversion =>{
            if(moment.unix(conversion.timestamp.seconds).format('YYYY-MM-DD') == dayDate){
              data[index]++
            }
          })
      })
      return data
    },

    chooseAllSources () {
      return this.selectedSources.length === this.sources.length
    },

    selectSomeSources () {
      return this.selectedSources.length > 0 && !this.chooseAllSources
    },

    icon () {
      if(this.chooseAllSources) return 'check_box'
      if(this.selectSomeSources) return 'indeterminate_check_box'
      return 'check_box_outline_blank'
    },

    conversionsFiltered(){
      let filterdConversions = []
      if(this.conversions.length > 0){
        this.conversionsClustered.forEach(conversion=>{ 
          
          if(this.activeBranch.id != 'all'){
            if(!conversion.salonhubData || conversion.salonhubData && conversion.salonhubData.branch && conversion.salonhubData.branch == this.activeBranch.branchNameSalonhub){
              let source = _.indexOf(this.filter.selectedSources, conversion.source);
              if(source >= 0){
                filterdConversions.push(conversion)
              }
            }
          }
          else{
            let source = _.indexOf(this.filter.selectedSources, conversion.source);
            if(source >= 0){
              filterdConversions.push(conversion)
            }
          }
          
        })
        return filterdConversions
      } 
      else {
        return filterdConversions
      }
    },

    conversionsSuccessRate(){
      let successCounter = 0
      let succesRate = 0

      if(this.conversionsFiltered.length > 0){
        this.conversionsFiltered.forEach(conversion=>{  
          if(conversion.progress && conversion.progress.completed){
            successCounter++
          }
        })
      }

      succesRate = (successCounter / this.conversionsFiltered.length * 100).toFixed(0)
      return succesRate
    },

    conversionsValue(){
      let successValue = 0;
      let value = 0;

      if(this.conversionsFiltered.length > 0){
        this.conversionsFiltered.forEach(conversion=>{  
          if(conversion.progress && conversion.progress.completed && conversion.value && conversion.value.type == 'amount'){
            successValue = successValue + conversion.value.number
          }
        })
      }
      value = successValue.toFixed(0)
      return value
    },

    newClientsSuccess(){
      let clientsSuccess = 0;

      if(this.conversionsFiltered.length > 0){
        this.conversionsFiltered.forEach(conversion=>{  
          if(conversion.salonhubData && !conversion.salonhubData.existingClient && conversion.progress && conversion.progress.completed){
            clientsSuccess++
          }
        })
      }
      return clientsSuccess;
    },

    newClients(){
      let clients = 0;

      if(this.conversionsFiltered.length > 0){
        this.conversionsFiltered.forEach(conversion=>{  
          if(conversion.salonhubData && !conversion.salonhubData.existingClient){
            clients++
          }
        })
      }
      return clients
    },

    adWordsCosts(){
      if(this.activeCompData.conversion.adwordsBudget){
        let budget = this.activeCompData.conversion.adwordsBudget;
        if(this.conversionPeriodType == 'day'){
          return budget;
        }
        if(this.conversionPeriodType == 'week'){
          let dayOfWeek = Number(moment().day()) + 1;
          return budget * dayOfWeek;
        }
        if(this.conversionPeriodType == 'month'){
          if(moment() > moment(this.conversionPeriodEnd, "D MMMM YYYY")){
            return budget * 30;
          }
          else{
            let dayOfMonth = Number(moment().format('D'))
            return budget * dayOfMonth;
          }
        }
      }
      else {
        return null;
      }
    },

    extraConversionPotential(){
      let convertedClients = 0;
      let convertedRevenue = 0;

      let potentialClientsWithPrice = 0;
      let potentialClientsWithoutPrice = 0;
      let potentialRevenue = 0;
      let counter = 0;
  
      if(this.conversionsFiltered.length > 0){
        this.conversionsFiltered.forEach(conversion=>{  
          if(conversion.progress.completed && conversion.salonhubData && conversion.salonhubData.steps && conversion.salonhubData.steps.treatment && conversion.salonhubData.steps.treatment.price){
            convertedClients++
            if(conversion.salonhubData){
              convertedRevenue = Number(convertedRevenue + conversion.salonhubData.steps.treatment.price);
            }
          }
          else if(!conversion.progress.completed && conversion.salonhubData && conversion.salonhubData.steps && conversion.salonhubData.steps.treatment && conversion.salonhubData.steps.treatment.price){
            potentialClientsWithPrice++
            potentialRevenue = Number(potentialRevenue + conversion.salonhubData.steps.treatment.price);
          }
          else{
            potentialClientsWithoutPrice++
          }       
        })

        if(convertedRevenue && convertedClients && potentialClientsWithoutPrice){
          potentialRevenue = ((convertedRevenue / convertedClients) * potentialClientsWithoutPrice) + potentialRevenue;
        }
        
        
        return potentialRevenue.toFixed(0);
      }
      else{
        return potentialRevenue.toFixed(0);
      }      
    }, 

    manualConversions(){
      let called = 0;
      let success = 0;
      let worth = 0;

      if(this.conversionsFiltered.length > 0){
        this.conversionsFiltered.forEach(conversion=>{  
          if(conversion.progress.completedBy != 'user'){
            called++
            if(conversion.progress.completed){
              success++
              if(conversion.value && conversion.value.type == 'amount' && conversion.value.number){
                worth = worth + conversion.value.number;
              }
            }
            
          }
        })
        return {
          called: called,
          success: success,
          worth: worth
        };
      }
      else{
        return {
            called: called,
            success: success,
            worth: worth
          };
      }
    },

    hogansConversions(){
      let called = 0;
      let success = 0;
      let costs = 0;

      if(this.conversionsFiltered.length > 0){
        this.conversionsFiltered.forEach(conversion=>{  
          if(conversion.progress.completedBy != 'user'){
            if(conversion.progress.completedByCompId && (conversion.companyId != conversion.progress.completedByCompId)){
              called++
              costs = costs + 1;
              if(conversion.progress.completed){
                success++
                costs = costs + 2;
              }
            }
          }
          
        })
        return {
          called: called,
          success: success,
          costs: costs
        };
      }
      else{
        return {
            called: called,
            success: success,
            costs: costs
          };
      }
    },

    messagesSend(){
      let number = 0;
      let costs = 0;

      if(this.conversionsFiltered.length > 0){
        this.conversionsFiltered.forEach(conversion=>{ 
          if(conversion.smsSend || conversion.clusterSmsSend){
            number++
            costs = (number * this.pricePerMessageSend).toFixed(2)
          }
        })
        return {
          number: number,
          costs: costs
        };
      }
      else{
        return {
            number: number,
            costs: costs
          };
      }

    },

    sourcesFilterChanged(){
      if (_.isEqual(this.filter.selectedSources, this.selectedSources) == false) {
        return true;
      } else {
        return false;
      }
    },

    activeYears(){
      let currentYear = Number(moment().year())
      let startDateCompany = moment().format("YYYY-MM-DD")

      if(this.activeCompData.conversion.start){
        startDateCompany = moment.unix(this.activeCompData.conversion.start.seconds).format("YYYY-MM-DD")
      }

      let numberOfYears = moment().diff(startDateCompany, 'years', false) + 1;
      // console.log("numberOfYears: ", numberOfYears)
      let activeYears = Array.apply(null, Array(numberOfYears))
      let counter = 0

      activeYears.forEach((year, index)=>{
        activeYears[index] = currentYear - counter
        counter++
      })
      return activeYears
    },

    months(){
      let months = [
        { id: 1, name: "Januari", disabled: false },
        { id: 2, name: "Februari", disabled: false },
        { id: 3, name: "Maart", disabled: false },
        { id: 4, name: "April", disabled: false },
        { id: 5, name: "Mei", disabled: false },
        { id: 6, name: "Juni", disabled: false },
        { id: 7, name: "Juli", disabled: false },
        { id: 8, name: "Augustus", disabled: false },
        { id: 9, name: "September", disabled: false },
        { id: 10, name: "Oktober", disabled: false },
        { id: 11, name: "November", disabled: false },
        { id: 12, name: "December", disabled: false },  
      ]

      if(this.selectedPeriodYear == moment().year()){
        months.forEach(month=>{
          if(month.id > Number(this.currentMonth)){
            month.disabled = true
          } 
          else{
            if(this.selectedPeriodYear == moment.unix(this.activeCompData.conversion.start.seconds).format("YYYY")){
              if(this.activeCompData.conversion.start && (month.id < Number(moment.unix(this.activeCompData.conversion.start.seconds).format("M")))){
                month.disabled = true
              } 
            }
          }
        })
        return months
      }
      else if(this.selectedPeriodYear == this.compStartYear){
        months.forEach(month=>{
          if(month.id < this.compStartMonth){
            month.disabled = true
          } 
        })
        return months
      } else{
        return months
      }
    },

    filterButtonDisabled(){
      if((this.selectedPeriodYear == moment().year() && this.currentMonth < this.selectedPeriodMonth) || this.selectedPeriodYear == this.compStartYear && this.selectedPeriodMonth < this.compStartMonth){
        return true
      } else {
        return false
      }
    },

    todaySelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterToday && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterToday){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },

    weekSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterWeek && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterWeek){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },

    monthSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterMonth && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterMonth){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },
    
    periodSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterPeriod && this.dataLoading){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterPeriod){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
      } 
      return data
    },

    randomHipster(){
      if(this.conversionsFiltered.length == 0){
        let randomNumber = Math.floor(Math.random() * 12) + 1;
        let hipsterClass = "hipster-" + randomNumber
         return hipsterClass
      } else {
        return null
      }    
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userOperator() {
      return this.$store.state.userOperator;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    demoMode(){
      return this.$store.state.demoMode;
    },
    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    },
    adminUser(){
      if(this.userRole == 'superadmin'){
        return true
      } else {
        return false
      }
    },
    changed() {
      if (_.isEqual(this.activeCompData, this.activeCompDataOriginal) == false) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>

<style>

.update-snackbar .v-snack__wrapper{
  min-width: 450px!important;
  z-index: 999;
}

.attempt-box{
  display: block;
  width: 32px;
  height: 32px;
  background-color: var(--v-text-base);
  border-radius: 50px;
  font-size: 11px;
  text-align: center;
  line-height: 34px;
  color: var(--v-menu-base);
}

.attempt-box span{
  font-size: 15px;
  color: var(--v-menu-base);
  padding: 0 1px 0 0;
}

.extra-conversion-info h3{
  padding: 0 0 10px 0;
}

.conversion-client-info .info-wrapper:after{
  display: block;
  clear: both;
  content: "";
}

.conversion-client-info .info-label{
  font-weight: 600;
  width: 120px;
  float: left;
  display: block;
}

.conversion-client-info .info-data{
  width: calc(100% - 120px);
  display: block;
  float: left;
}

.no-conversions{
  width: 280px;
  margin: 0px auto;
  padding: 80px 0;
}

.hipster-image{
  width: 130px;
  height: 130px;
  margin: 0 auto;
}

.no-conversions p{
  font-weight: 600;
  text-align: center;
  font-size: 16px;
}

.hipster-1{
  background: url('../assets/hipsters/hipster-1.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-2{
  background: url('../assets/hipsters/hipster-2.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-3{
  background: url('../assets/hipsters/hipster-3.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-4{
  background: url('../assets/hipsters/hipster-4.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-5{
  background: url('../assets/hipsters/hipster-5.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-6{
  background: url('../assets/hipsters/hipster-6.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-7{
  background: url('../assets/hipsters/hipster-7.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-8{
  background: url('../assets/hipsters/hipster-8.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-9{
  background: url('../assets/hipsters/hipster-9.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-10{
  background: url('../assets/hipsters/hipster-10.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-11{
  background: url('../assets/hipsters/hipster-11.png') no-repeat center center;
  background-size: 110px auto;
}
.hipster-12{
  background: url('../assets/hipsters/hipster-12.png') no-repeat center center;
  background-size: 110px auto;
}

.conversion-selected-period p {
  text-align: center;
  padding: 15px 0 5px 0;
  text-transform: lowercase;
}

.v-toolbar.custom-toolbar .v-toolbar__content, 
.v-toolbar.custom-toolbar .v-toolbar__extension{
   padding: 0!important;
}

.conversion-table table head td:not(:nth-child(1)), 
.conversion-table table tbody td:not(:nth-child(1)), 
.conversion-table table thead th:not(:nth-child(1)), 
.conversion-table table tbody th:not(:nth-child(1)), 
.conversion-table table thead td:first-child, 
.conversion-table table tbody td:first-child, 
.conversion-table table thead th:first-child, 
.conversion-table table tbody th:first-child {
    padding: 0 8px!important;
}

.close-conversion-buttons{
  border-radius: 5px;
  overflow: hidden;
  -webkit-box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
}

.close-conversion-buttons:after{
  display: block;
  content: "";
  clear: both;
}

.close-conversion-button{
  width: 33.3%;
  border: 1px solid #251433;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #fff;
  color: #251433;
  float: left;
  text-transform: uppercase;
  font-weight: bold;
  cursor: pointer;
}
.close-conversion-button.left{
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}

.close-conversion-button.middle{
  border-right: none;
  border-left: none;
}

.close-conversion-button.right{
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.close-conversion-button.active{
  background-color: #251433;
  color: #fff;
}

tr.buzy{
  background-color: rgba(0,0,0,0.09);
}
</style>
